// // LandingPage.tsx
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import {
//   FaUserClock,
//   FaMapMarkerAlt,
//   FaCalculator,
//   FaChartLine,
//   FaMobileAlt,
//   FaShieldAlt,
//   FaSync,
//   FaCheckCircle,
//   FaArrowRight,
//   FaUsers,
//   FaFileInvoiceDollar,
//   FaRobot,
//   FaWhatsapp,
//   FaShoppingCart,
//   FaCreditCard,
//   FaClock,
//   FaCloud,
//   FaLock,
//   FaEye,
//   FaEyeSlash,
//   FaBars,
//   FaTimes,
// } from "react-icons/fa";
// import { Button } from "../components/ui/button";
// import { Input } from "../components/ui/input";
// import { Label } from "../components/ui/label";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
//   CardDescription,
// } from "../components/ui/card";
// import { useToast } from "../hooks/useToast";
// import { useAuth } from "../contexts/AuthContext";

// type LoginForm = {
//   email: string;
//   password: string;
// };

// const LandingPage: React.FC = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [activeFeature, setActiveFeature] = useState(0);

//   const navigate = useNavigate();
//   const { toast } = useToast();
//   const { login, user } = useAuth();

//   useEffect(() => {
//   if (user) {
//     navigate("/dashboard");
//   }
// }, [user]);

//   const { register, handleSubmit } = useForm<LoginForm>();

//   const features = [
//     {
//       icon: <FaMapMarkerAlt />,
//       title: "Location-Based Attendance",
//       description:
//         "Track employee attendance automatically from any location using GPS and geofencing technology.",
//       color: "bg-blue-500",
//     },
//     {
//       icon: <FaCalculator />,
//       title: "Automated Payroll Processing",
//       description:
//         "Calculate salaries, taxes, and deductions automatically based on attendance data.",
//       color: "bg-green-500",
//     },
//     {
//       icon: <FaChartLine />,
//       title: "AI-Powered Analytics",
//       description:
//         "Get insights into workforce productivity with AI-driven analytics and reports.",
//       color: "bg-purple-500",
//     },
//     {
//       icon: <FaMobileAlt />,
//       title: "Mobile App & WhatsApp",
//       description:
//         "Employees can mark attendance, view payslips via mobile app or WhatsApp.",
//       color: "bg-orange-500",
//     },
//     {
//       icon: <FaShieldAlt />,
//       title: "Bank-Level Security",
//       description:
//         "End-to-end encryption, multi-factor authentication, and data protection compliance.",
//       color: "bg-red-500",
//     },
//     {
//       icon: <FaSync />,
//       title: "Auto Reconciliation",
//       description:
//         "Advanced auto reconciliations with seamless bank statement imports.",
//       color: "bg-teal-500",
//     },
//   ];

//   const stats = [
//     { value: "10,000+", label: "Happy Companies" },
//     { value: "₹399", label: "Starting Price/Month" },
//     { value: "99.9%", label: "Uptime" },
//     { value: "24/7", label: "Support" },
//   ];

//   const onSubmit = async (data: LoginForm) => {
//     try {
//       setLoading(true);
//       await login(data.email, data.password);

//       toast({
//         title: "Success",
//         description: "Logged in successfully",
//       });

//       navigate("/dashboard");
//     } catch (error) {
//       toast({
//         variant: "destructive",
//         title: "Error",
//         description: "Invalid credentials",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveFeature((prev) => (prev + 1) % features.length);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   const scrollToSection = (sectionId: string) => {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: "smooth" });
//       setIsMenuOpen(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
//       {/* Fixed Navigation */}
//       <nav className="fixed w-full top-0 left-0 bg-white/90 backdrop-blur-md z-50 shadow-sm">
//         <div className="container mx-auto px-4 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-2">
//               <FaUserClock className="text-blue-600 text-2xl" />
//               <span className="text-xl font-bold text-gray-900">
//                 HRPayroll
//               </span>
//             </div>

//             {/* Desktop Navigation */}
//             <div className="hidden md:flex items-center space-x-8">
//               <button
//                 onClick={() => scrollToSection("home")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Home
//               </button>
//               <button
//                 onClick={() => scrollToSection("features")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Features
//               </button>
//               <button
//                 onClick={() => scrollToSection("pricing")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Pricing
//               </button>
//               <button
//                 onClick={() => scrollToSection("login")}
//                 className="text-gray-700 hover:text-blue-600 transition"
//               >
//                 Login
//               </button>
//             </div>

//             {/* Mobile Menu Button */}
//             <button
//               className="md:hidden text-gray-700"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//             >
//               {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//             </button>
//           </div>

//           {/* Mobile Menu */}
//           {isMenuOpen && (
//             <div className="md:hidden mt-4 pb-4 animate-in slide-in-from-top">
//               <div className="flex flex-col space-y-4">
//                 <button
//                   onClick={() => scrollToSection("home")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Home
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("features")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Features
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("pricing")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Pricing
//                 </button>
//                 <button
//                   onClick={() => scrollToSection("login")}
//                   className="text-gray-700 hover:text-blue-600 py-2"
//                 >
//                   Login
//                 </button>
//                 <Button
//                   onClick={() => scrollToSection("register")}
//                   className="bg-blue-600 hover:bg-blue-700 w-full"
//                 >
//                   Start Free Trial
//                 </Button>
//               </div>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <section id="home" className="pt-24 pb-16 md:pt-32 md:pb-24 px-4">
//         <div className="container mx-auto">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div>
//               <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
//                 The Ultimate HR Payroll Platform
//                 {/* <span className="text-blue-600 block">With AI Automation</span> */}
//               </h1>
//               <p className="text-lg text-gray-600 mb-8">
//                 HRPayroll offers cutting-edge HR & Payroll Software for seamless
//                 workforce management. Our advanced platform integrates AI
//                 technology, automatic attendance tracking from any location, tax
//                 filing, and mobile solutions, revolutionizing the HR landscape.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <Button
//                   onClick={() => scrollToSection("register")}
//                   className="bg-blue-600 hover:bg-blue-700 px-8 py-6 text-lg"
//                 >
//                   <span>Start Today, Right Now</span>
//                   <FaArrowRight className="ml-2" />
//                 </Button>
//                 <Button
//                   onClick={() => scrollToSection("pricing")}
//                   variant="outline"
//                   className="px-8 py-6 text-lg"
//                 >
//                   View Pricing
//                 </Button>
//               </div>
//               <p className="mt-6 text-gray-500">
//                 <FaClock className="inline mr-2" />
//                 Paid plans starting from{" "}
//                 <span className="font-bold text-blue-600">₹399/month</span>
//               </p>
//             </div>

//             {/* Hero Image/Animation */}
//             <div className="relative">
//               <Card className="shadow-2xl border-0">
//                 <CardContent className="p-6">
//                   <div className="text-center mb-6">
//                     <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FaUserClock className="text-blue-600 text-2xl" />
//                     </div>
//                     <h3 className="text-xl font-bold">
//                       Live Dashboard Preview
//                     </h3>
//                   </div>

//                   {/* Feature Carousel */}
//                   <div className="mb-6">
//                     <div
//                       className={`p-4 rounded-lg ${features[activeFeature].color} text-white transition-all duration-500`}
//                     >
//                       <div className="flex items-center mb-2">
//                         <div className="text-2xl mr-3">
//                           {features[activeFeature].icon}
//                         </div>
//                         <h4 className="font-bold">
//                           {features[activeFeature].title}
//                         </h4>
//                       </div>
//                       <p className="text-sm">
//                         {features[activeFeature].description}
//                       </p>
//                     </div>

//                     {/* Feature Dots */}
//                     <div className="flex justify-center space-x-2 mt-4">
//                       {features.map((_, index) => (
//                         <button
//                           key={index}
//                           onClick={() => setActiveFeature(index)}
//                           className={`w-2 h-2 rounded-full ${index === activeFeature ? "bg-blue-600" : "bg-gray-300"}`}
//                         />
//                       ))}
//                     </div>
//                   </div>

//                   {/* Stats */}
//                   <div className="grid grid-cols-2 gap-4">
//                     <div className="bg-gray-50 p-4 rounded-lg">
//                       <div className="text-2xl font-bold text-blue-600">
//                         142
//                       </div>
//                       <div className="text-sm text-gray-600">Active Today</div>
//                     </div>
//                     <div className="bg-gray-50 p-4 rounded-lg">
//                       <div className="text-2xl font-bold text-green-600">
//                         89
//                       </div>
//                       <div className="text-sm text-gray-600">
//                         Remote Workers
//                       </div>
//                     </div>
//                   </div>
//                 </CardContent>
//               </Card>

//               {/* Floating Elements */}
//               <div className="absolute -top-4 -right-4 bg-white p-4 rounded-xl shadow-lg">
//                 <div className="flex items-center">
//                   <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
//                     <FaCheckCircle className="text-green-600" />
//                   </div>
//                   <div className="ml-3">
//                     <div className="font-bold">AI Powered</div>
//                     <div className="text-sm text-gray-500">Real-time</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-12 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//             {stats.map((stat, index) => (
//               <div key={index} className="text-center">
//                 <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
//                   {stat.value}
//                 </div>
//                 <div className="text-gray-600">{stat.label}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Section */}
//       <section id="features" className="py-16 px-4">
//         <div className="container mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Why Choose HRPayroll?
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Our advanced AI-Powered automation and seamless integrations
//               eliminate manual efforts, guaranteeing a smooth HR and payroll
//               experience.
//             </p>
//           </div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {features.map((feature, index) => (
//               <Card key={index} className="hover:shadow-xl transition-shadow">
//                 <CardContent className="p-6">
//                   <div
//                     className={`${feature.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}
//                   >
//                     <div className="text-white text-xl">{feature.icon}</div>
//                   </div>
//                   <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
//                   <p className="text-gray-600">{feature.description}</p>
//                 </CardContent>
//               </Card>
//             ))}
//           </div>

//           {/* Additional Features */}
//           <div className="mt-16 grid md:grid-cols-3 gap-8">
//             <div className="text-center">
//               <FaRobot className="text-4xl text-blue-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">AI-Powered Automation</h4>
//               <p className="text-gray-600">
//                 Smart automation for payroll calculations and compliance
//               </p>
//             </div>
//             <div className="text-center">
//               <FaWhatsapp className="text-4xl text-green-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">WhatsApp Integration</h4>
//               <p className="text-gray-600">
//                 Send payslips and alerts via WhatsApp instantly
//               </p>
//             </div>
//             <div className="text-center">
//               <FaCloud className="text-4xl text-purple-600 mx-auto mb-4" />
//               <h4 className="font-bold text-lg mb-2">Cloud Platform</h4>
//               <p className="text-gray-600">
//                 Access from anywhere, anytime with 99.9% uptime
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Login/Register Section */}
//       <section
//         id="login"
//         className="py-16 px-4 bg-gradient-to-r from-blue-50 to-indigo-50"
//       >
//         <div className="container mx-auto max-w-6xl">
//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* Login Form */}
//             <Card className="shadow-xl">
//               <CardHeader>
//                 <CardTitle>Login to Your Account</CardTitle>
//                 <CardDescription>
//                   Enter your credentials to access the HR dashboard
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
//                   <div className="space-y-2">
//                     <Label htmlFor="email">Email</Label>
//                     <Input
//                       id="email"
//                       type="email"
//                       placeholder="Enter your email"
//                       {...register("email", { required: true })}
//                     />
//                   </div>
//                   <div className="space-y-2">
//                     <Label htmlFor="password">Password</Label>
//                     <div className="relative">
//                       <Input
//                         id="password"
//                         type={showPassword ? "text" : "password"}
//                         placeholder="Enter your password"
//                         {...register("password", { required: true })}
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="absolute right-3 top-3 text-gray-500"
//                       >
//                         {showPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                   </div>
//                   <Button type="submit" className="w-full" disabled={loading}>
//                     {loading ? "Loading..." : "Sign In"}
//                   </Button>
//                 </form>
//                 <div className="mt-4 text-center">
//                   <button
//                     onClick={() => navigate("/forgot-password")}
//                     className="text-sm text-blue-600 hover:underline"
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Register CTA */}
//             <div id="register">
//               <Card className="shadow-xl bg-gradient-to-br from-blue-600 to-blue-800 text-white">
//                 <CardContent className="p-8">
//                   <div className="text-center mb-6">
//                     <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FaUserClock className="text-2xl" />
//                     </div>
//                     <h3 className="text-2xl font-bold mb-2">
//                       Start Your Free Trial
//                     </h3>
//                     <p className="text-blue-100 mb-6">
//                       Join thousands of companies already using HRPayroll
//                     </p>
//                   </div>

//                   <div className="space-y-4 mb-6">
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>30-day free trial</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>No credit card required</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>Full access to all features</span>
//                     </div>
//                     <div className="flex items-center">
//                       <FaCheckCircle className="text-green-400 mr-3" />
//                       <span>Priority support</span>
//                     </div>
//                   </div>

//                   <Button
//                     onClick={() => navigate("/register")}
//                     className="w-full bg-white text-blue-600 hover:bg-gray-100"
//                   >
//                     Register Now
//                   </Button>

//                   <p className="text-center mt-4 text-blue-200 text-sm">
//                     Paid plans starting from ₹399/month after trial
//                   </p>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       <section id="pricing" className="py-16 px-4">
//         <div className="container mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Simple, Transparent Pricing
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Choose the perfect plan for your business needs
//             </p>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
//             {/* Basic Plan */}
//             <Card className="text-center">
//               <CardContent className="p-6">
//                 <h3 className="text-xl font-bold mb-2">Starter</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   ₹399<span className="text-sm text-gray-500">/month</span>
//                 </div>
//                 <p className="text-gray-600 mb-6">
//                   Perfect for small businesses
//                 </p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Up to 10 employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Basic payroll processing</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Mobile attendance</span>
//                   </div>
//                 </div>
//                 <Button className="w-full">Get Started</Button>
//               </CardContent>
//             </Card>

//             {/* Popular Plan */}
//             <Card className="text-center border-2 border-blue-600 shadow-xl relative">
//               <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
//                 <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm">
//                   MOST POPULAR
//                 </span>
//               </div>
//               <CardContent className="p-6 pt-10">
//                 <h3 className="text-xl font-bold mb-2">Professional</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   ₹899<span className="text-sm text-gray-500">/month</span>
//                 </div>
//                 <p className="text-gray-600 mb-6">Best for growing companies</p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Up to 50 employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>AI-powered analytics</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Auto reconciliations</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>WhatsApp integration</span>
//                   </div>
//                 </div>
//                 <Button className="w-full bg-blue-600 hover:bg-blue-700">
//                   Try Free for 30 Days
//                 </Button>
//               </CardContent>
//             </Card>

//             {/* Enterprise Plan */}
//             <Card className="text-center">
//               <CardContent className="p-6">
//                 <h3 className="text-xl font-bold mb-2">Enterprise</h3>
//                 <div className="text-3xl font-bold text-blue-600 mb-4">
//                   Custom
//                 </div>
//                 <p className="text-gray-600 mb-6">For large organizations</p>
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Unlimited employees</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Custom integrations</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>Dedicated support</span>
//                   </div>
//                   <div className="flex items-center">
//                     <FaCheckCircle className="text-green-500 mr-2" />
//                     <span>API access</span>
//                   </div>
//                 </div>
//                 <Button className="w-full">Contact Sales</Button>
//               </CardContent>
//             </Card>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-900 text-white py-12 px-4">
//         <div className="container mx-auto">
//           <div className="grid md:grid-cols-4 gap-8">
//             <div>
//               <div className="flex items-center space-x-2 mb-4">
//                 <FaUserClock className="text-2xl text-blue-400" />
//                 <span className="text-xl font-bold">HRPayroll</span>
//               </div>
//               <p className="text-gray-400">
//                 Revolutionizing HR management with automated attendance tracking
//                 and payroll processing.
//               </p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <ul className="space-y-2">
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("home")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Home
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("features")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Features
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => scrollToSection("pricing")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Pricing
//                   </button>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Resources</h4>
//               <ul className="space-y-2">
//                 <li>
//                   <button
//                     onClick={() => navigate("/blog")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Blog
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => navigate("/docs")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Documentation
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     onClick={() => navigate("/support")}
//                     className="text-gray-400 hover:text-white"
//                   >
//                     Support
//                   </button>
//                 </li>
//               </ul>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <ul className="space-y-2 text-gray-400">
//                 <li>info@startupkhata.com support@startupkhata.com</li>
//                 {/* <li>+91 12345 67890</li> */}
//                 <li>24/7 Support Available</li>
//               </ul>
//             </div>
//           </div>

//           <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
//             <p>
//               &copy; {new Date().getFullYear()} HRPayroll. All rights reserved.
//             </p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default LandingPage;



// LandingPage.tsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  FaUserClock,
  FaMapMarkerAlt,
  FaCalculator,
  FaChartLine,
  FaMobileAlt,
  FaShieldAlt,
  FaSync,
  FaCheckCircle,
  FaArrowRight,
  FaRobot,
  FaEye,
  FaEyeSlash,
  FaBars,
  FaTimes,
  FaBuilding,
} from "react-icons/fa";
import { useToast } from "../hooks/useToast";
import { useAuth } from "../contexts/AuthContext";
import { getOrganizations } from "../api/auth";

type LoginForm = {
  email: string;
  password: string;
};

interface Organization {
  head_office_id: string;
  company_name: string;
  organization: string;
}

/* ──────────────── Count-up number ──────────────── */
const Counter: React.FC<{ value: number; suffix?: string; prefix?: string; duration?: number; format?: (n: number) => string }> = ({
  value,
  suffix = "",
  prefix = "",
  duration = 1800,
  format,
}) => {
  const ref = React.useRef<HTMLSpanElement>(null);
  const [display, setDisplay] = React.useState(0);
  React.useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setDisplay(value);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const start = performance.now();
            const tick = (t: number) => {
              const elapsed = t - start;
              const progress = Math.min(elapsed / duration, 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              setDisplay(value * eased);
              if (progress < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [value, duration]);
  const formatted = format ? format(display) : Math.round(display).toLocaleString("en-IN");
  return <span ref={ref}>{prefix}{formatted}{suffix}</span>;
};
/* ──────────────── /Count-up number ──────────────── */

/* ──────────────── Tour mock dashboards ──────────────── */
const MockShell: React.FC<{ menu: string; eyebrow: string; title: React.ReactNode; children: React.ReactNode; right?: React.ReactNode }> = ({ menu, eyebrow, title, children, right }) => (
  <div className="w-full h-full bg-[#faf8f3] flex text-[#1a1a1a]" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
    <aside className="w-[100px] sm:w-[130px] shrink-0 bg-[#fbf8f1] border-r border-[#e8e3d8] py-3 px-2.5 flex flex-col gap-0.5">
      <div className="lp-mono text-[7px] tracking-[0.22em] uppercase text-[#8a8580] mb-2 px-1.5">Menu</div>
      {["Dashboard", "Employees", "Attendance", "Leaves", "Tasks", "Payroll", "Reports"].map((item) => {
        const active = item === menu;
        return (
          <div
            key={item}
            className={`text-[9px] py-1.5 px-2 rounded-md ${active ? "bg-[#e8efe9] text-[#0f2d1f] font-semibold" : "text-[#4a4a4a]"}`}
          >
            {item}
          </div>
        );
      })}
    </aside>
    <div className="flex-1 min-w-0 p-3 sm:p-4 flex flex-col">
      <div className="flex items-start justify-between mb-3 gap-3">
        <div>
          <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "8px" }}>{eyebrow}</div>
          <div
            className="lp-serif text-[#0f2d1f] leading-tight"
            style={{
              fontFamily: "'Fraunces', Georgia, serif",
              fontSize: "clamp(16px, 2vw, 22px)",
              fontWeight: 500,
              letterSpacing: "-0.02em",
            }}
          >
            {title}
          </div>
        </div>
        {right && <div className="shrink-0 flex items-center gap-2">{right}</div>}
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
    </div>
  </div>
);

const Pill: React.FC<{ children: React.ReactNode; tone?: "dark" | "ghost" }> = ({ children, tone = "ghost" }) => (
  <div
    className={`inline-flex items-center gap-1 text-[8px] px-2 py-1 rounded-full ${
      tone === "dark" ? "bg-[#0f2d1f] text-[#faf8f3]" : "bg-[#fbf8f1] border border-[#e8e3d8] text-[#1a1a1a]"
    }`}
  >
    {children}
  </div>
);

const EmployeesMock: React.FC = () => (
  <MockShell
    menu="Employees"
    eyebrow="II. PEOPLE"
    title={<>Employee <span style={{ fontStyle: "italic" }}>Management</span></>}
    right={
      <>
        <Pill tone="dark">+ Add</Pill>
        <Pill>↑ Import</Pill>
      </>
    }
  >
    <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded-md px-2.5 py-1.5 mb-2 flex items-center gap-2 text-[9px] text-[#8a8580] lp-mock-fade">
      <span className="w-2 h-2 rounded-full border border-[#8a8580]" />
      Search employees…
      <span className="ml-auto text-[8px]">All Departments ⌄</span>
    </div>
    <div className="lp-mock-stagger grid grid-cols-3 gap-1.5">
      {[
        { n: "Mansi Rathour", e: "rathourmansi92@gmail.com", id: "137", j: "May 2, 2026" },
        { n: "Abhinash N/A", e: "abhinashkardav@gmail.com", id: "136", j: "Jan 6, 2026" },
        { n: "Tanisha N/A", e: "tanishakapoor963@gmail.com", id: "135", j: "Jun 2, 2025" },
        { n: "Sumit Chaudhary", e: "sumitskc123@gmail.com", id: "134", j: "Apr 28, 2025" },
        { n: "Vikas Sahni", e: "sahnivikas93@gmail.com", id: "133", j: "Apr 21, 2025" },
        { n: "Kajal N/A", e: "kajalsahani257@gmail.com", id: "132", j: "Jan 6, 2025" },
      ].map((emp, i) => (
        <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
          <div className="flex items-center gap-1.5 mb-1">
            <div className="w-6 h-6 rounded-full bg-[#e8efe9] text-[#0f2d1f] flex items-center justify-center text-[9px] font-semibold">
              {emp.n[0]}
            </div>
            <div className="text-[9px] font-semibold text-[#1a1a1a] truncate flex-1 uppercase tracking-wide">{emp.n}</div>
          </div>
          <div className="text-[8px] text-[#4a4a4a] mb-1">
            Accountant · <span className="inline-flex items-center gap-1 text-[#2f9e6c]"><span className="w-1 h-1 rounded-full bg-[#2f9e6c]" />Active</span>
          </div>
          <div className="text-[8px] text-[#8a8580] truncate">{emp.e}</div>
          <div className="text-[8px] text-[#8a8580] mt-0.5">№ {emp.id} · {emp.j}</div>
        </div>
      ))}
    </div>
  </MockShell>
);

const AttendanceMock: React.FC = () => (
  <MockShell
    menu="Attendance"
    eyebrow="III. OPERATIONS"
    title={<>Attendance <span style={{ fontStyle: "italic" }}>Management</span></>}
  >
    <div className="lp-mock-stagger grid grid-cols-4 gap-1.5 mb-2.5">
      {[
        { l: "Total", v: "20", c: "#0f2d1f" },
        { l: "Present", v: "18", c: "#2f9e6c" },
        { l: "Absent", v: "02", c: "#c4574c" },
        { l: "Rate", v: "90%", c: "#0f2d1f" },
      ].map((s, i) => (
        <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
          <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>{s.l} TODAY</div>
          <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: s.c, fontSize: "20px", fontWeight: 500, lineHeight: 1, letterSpacing: "-0.02em", animationDelay: `${i * 80 + 200}ms` }}>
            {s.v}
          </div>
        </div>
      ))}
    </div>
    <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2.5 mb-2 lp-mock-fade" style={{ animationDelay: "350ms" }}>
      <div className="flex items-center gap-1.5 mb-2">
        <span className="w-1 h-3 bg-[#0f2d1f] rounded-full" />
        <span className="text-[9px] font-semibold text-[#0f2d1f]">Advanced Filters</span>
        <span className="text-[8px] text-[#8a8580]">Filter attendance records</span>
      </div>
      <div className="grid grid-cols-2 gap-1.5 mb-2">
        <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded px-2 py-1 text-[8px] text-[#4a4a4a]">📅 Start · 09 / 05 / 2026</div>
        <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded px-2 py-1 text-[8px] text-[#4a4a4a]">📅 End · 09 / 05 / 2026</div>
      </div>
      <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded px-2 py-1 text-[8px] text-[#8a8580] mb-2">🔍 Search by employee name…</div>
      <div className="grid grid-cols-3 gap-1">
        <div className="bg-[#0f2d1f] text-[#faf8f3] text-[8px] py-1 rounded text-center">All</div>
        <div className="bg-[#fbf8f1] border border-[#e8e3d8] text-[8px] py-1 rounded text-center text-[#1a1a1a]">⊘ Present</div>
        <div className="bg-[#fbf8f1] border border-[#e8e3d8] text-[8px] py-1 rounded text-center text-[#1a1a1a]">⊗ Absent</div>
      </div>
    </div>
    <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2.5">
      <div className="flex items-center gap-1.5 mb-1.5">
        <span className="w-1 h-3 bg-[#0f2d1f] rounded-full" />
        <span className="text-[9px] font-semibold text-[#0f2d1f]">Employee Status</span>
        <span className="ml-auto text-[8px] text-[#8a8580]">📅 05-09 → 05-09</span>
      </div>
      <div className="grid grid-cols-4 gap-1 text-[7px] tracking-wider uppercase text-[#8a8580] pb-1 border-b border-[#efeae0]">
        <span>Employee</span><span>Status</span><span>In</span><span>Out</span>
      </div>
      {["Priya Sharma", "Arjun Mehta", "Kavya Rao"].map((n, i) => (
        <div key={i} className="grid grid-cols-4 gap-1 text-[8px] py-1 border-b border-[#efeae0] items-center">
          <span className="truncate">{n}</span>
          <span className="text-[#2f9e6c]">● Present</span>
          <span className="lp-mono">9:0{i + 1} AM</span>
          <span className="lp-mono text-[#8a8580]">—</span>
        </div>
      ))}
    </div>
  </MockShell>
);

const PlannerMock: React.FC = () => (
  <MockShell
    menu="Tasks"
    eyebrow="I. TODAY · SATURDAY"
    title={<>Daily <span style={{ fontStyle: "italic" }}>Planner</span></>}
    right={<Pill tone="dark">⊕ Plan task</Pill>}
  >
    <div className="lp-mock-stagger grid grid-cols-4 gap-1.5 mb-2.5">
      {[
        { l: "Today", v: "01", c: "#0f2d1f", bg: "#e8efe9" },
        { l: "Done", v: "00", c: "#2f9e6c", bg: "#e8efe9" },
        { l: "Pending", v: "01", c: "#d4a356", bg: "#fef3c7" },
        { l: "Overdue", v: "04", c: "#c4574c", bg: "#fdecea" },
      ].map((s, i) => (
        <div key={i} className="rounded-md p-2 border border-[#e8e3d8] lp-soft-hover" style={{ background: s.bg }}>
          <div className="lp-eyebrow" style={{ fontSize: "7px", color: s.c, opacity: 0.8 }}>{s.l}</div>
          <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: s.c, fontSize: "20px", fontWeight: 500, lineHeight: 1, letterSpacing: "-0.02em", animationDelay: `${i * 80 + 200}ms` }}>
            {s.v}
          </div>
        </div>
      ))}
    </div>
    <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded-md p-2 mb-2 flex items-center gap-2 lp-mock-fade" style={{ animationDelay: "350ms" }}>
      <div className="w-5 h-5 rounded-full bg-[#0f2d1f] text-[#faf8f3] flex items-center justify-center text-[10px]">+</div>
      <div className="text-[9px] text-[#8a8580] flex-1">What needs doing?</div>
      <Pill>Medium</Pill>
      <Pill>Reminder</Pill>
    </div>
    <div className="lp-mock-stagger grid grid-cols-3 gap-2">
      {[
        { lane: "Today", n: "01", icon: "☀", c: "#0f2d1f", task: "Gstr1 Correction", tag: "URGENT", tagC: "#c4574c", date: "May 9" },
        { lane: "Upcoming", n: "01", icon: "📆", c: "#d4a356", task: "TDS Meeting", tag: "MEDIUM", tagC: "#d4a356", date: "May 10" },
        { lane: "Missed", n: "04", icon: "⚠", c: "#c4574c", task: "GST applie", tag: "LOW", tagC: "#1e3a8a", date: "May 8" },
      ].map((col, i) => (
        <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2">
          <div className="flex items-center gap-1.5 mb-1.5">
            <span className="w-5 h-5 rounded-md flex items-center justify-center text-[10px]" style={{ background: col.c + "22", color: col.c }}>{col.icon}</span>
            <span className="text-[9px] font-semibold text-[#1a1a1a]">{col.lane}</span>
            <span className="ml-auto text-[8px] lp-mono text-[#8a8580]">{col.n}</span>
          </div>
          <div className="rounded border-l-2 bg-[#fbf8f1] p-1.5 lp-soft-hover" style={{ borderColor: col.c }}>
            <div className="text-[9px] font-semibold text-[#1a1a1a] mb-0.5">○ {col.task}</div>
            <div className="text-[7px] mb-1 inline-block px-1 py-0.5 rounded" style={{ background: col.tagC + "22", color: col.tagC }}>● {col.tag}</div>
            <div className="text-[7px] text-[#8a8580]">{col.date}</div>
            <div className="flex gap-1 mt-1">
              <span className="text-[7px] bg-[#e8eef6] text-[#2f4a73] px-1.5 py-0.5 rounded">▶ Progress</span>
              <span className="text-[7px] bg-[#2f9e6c] text-white px-1.5 py-0.5 rounded">✓ Done</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </MockShell>
);

const ReportsMock: React.FC = () => (
  <MockShell
    menu="Reports"
    eyebrow="III. INSIGHTS"
    title={<>Reports <span style={{ fontStyle: "italic" }}>Management</span></>}
  >
    <div className="flex items-center gap-1 mb-2 border-b border-[#efeae0] pb-1.5">
      {["Overview", "Projects", "Tasks", "Clients", "Employees", "Workload", "Timeline"].map((t, i) => (
        <span key={t} className={`text-[8px] px-2 py-1 ${i === 0 ? "text-[#0f2d1f] font-semibold border-b-2 border-[#0f2d1f] -mb-[7px]" : "text-[#8a8580]"}`}>
          {t}
        </span>
      ))}
    </div>
    <div className="lp-mock-stagger grid grid-cols-3 gap-1.5 mb-2">
      <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 row-span-2 flex flex-col items-center justify-center lp-soft-hover">
        <div className="lp-eyebrow text-[#8a8580] mb-1.5" style={{ fontSize: "7px" }}>I. PERFORMANCE</div>
        <div className="text-[10px] font-semibold text-[#1a1a1a] mb-2">Completion <span className="italic">Health</span></div>
        <div className="relative w-16 h-16">
          <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
            <circle cx="18" cy="18" r="15.5" fill="none" stroke="#ece8df" strokeWidth="3.5" />
            <circle cx="18" cy="18" r="15.5" fill="none" stroke="#2f9e6c" strokeWidth="3.5" strokeLinecap="round" strokeDasharray={`${28.6 * 0.974} 100`} pathLength={100} className="lp-mock-draw" style={{ ["--c" as any]: 100, ["--off" as any]: 0, animationDelay: "400ms" }} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="lp-serif lp-mock-num text-[#0f2d1f]" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "14px", fontWeight: 500, letterSpacing: "-0.02em", animationDelay: "700ms" }}>
              28.6<span style={{ fontSize: "8px" }}>%</span>
            </div>
            <div className="text-[6px] tracking-[0.18em] text-[#8a8580]">DONE</div>
          </div>
        </div>
        <div className="flex gap-2 mt-2 text-[7px]">
          <span className="text-[#0f2d1f]">● 2 done</span>
          <span className="text-[#8a8580]">● 5 open</span>
        </div>
      </div>
      <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
        <div className="flex items-start justify-between">
          <div>
            <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>CREATED</div>
            <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#0f2d1f", fontSize: "22px", fontWeight: 500, lineHeight: 1, animationDelay: "300ms" }}>7</div>
            <div className="text-[7px] text-[#8a8580] mt-0.5">new entries</div>
          </div>
          <span className="text-[10px]">✦</span>
        </div>
      </div>
      <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
        <div className="flex items-start justify-between">
          <div>
            <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>COMPLETED</div>
            <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#0f2d1f", fontSize: "22px", fontWeight: 500, lineHeight: 1, animationDelay: "400ms" }}>2</div>
            <div className="text-[7px] text-[#8a8580] mt-0.5">finished</div>
          </div>
          <span className="text-[10px]">🏅</span>
        </div>
      </div>
      <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
        <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>AVG PROGRESS</div>
        <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#0f2d1f", fontSize: "20px", fontWeight: 500, lineHeight: 1, animationDelay: "500ms" }}>30%</div>
        <div className="mt-1 h-1 w-full rounded-full bg-[#ece8df] overflow-hidden">
          <div className="h-full bg-[#0f2d1f] lp-mock-bar-x" style={{ width: "30%", ["--w" as any]: "30%", animationDelay: "700ms" }} />
        </div>
      </div>
      <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
        <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>OVERDUE</div>
        <div className="lp-serif lp-mock-num mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#2f9e6c", fontSize: "20px", fontWeight: 500, lineHeight: 1, animationDelay: "600ms" }}>0</div>
        <div className="text-[7px] text-[#2f9e6c] mt-0.5">all clear ✓</div>
      </div>
    </div>
    <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-mock-fade" style={{ animationDelay: "700ms" }}>
      <div className="flex items-center justify-between mb-1.5">
        <div className="text-[9px] font-semibold text-[#0f2d1f]">Status Breakdown</div>
        <Pill>3 states</Pill>
      </div>
      <div className="flex h-2.5 rounded-full overflow-hidden">
        <div className="bg-[#2f9e6c] lp-mock-bar-x" style={{ width: "28%", ["--w" as any]: "28%", animationDelay: "850ms" }} />
        <div className="bg-[#d4a356] lp-mock-bar-x" style={{ width: "44%", ["--w" as any]: "44%", animationDelay: "950ms" }} />
        <div className="bg-[#ece8df] lp-mock-bar-x" style={{ width: "28%", ["--w" as any]: "28%", animationDelay: "1050ms" }} />
      </div>
      <div className="flex gap-3 mt-1.5 text-[7px] text-[#8a8580]">
        <span><span className="inline-block w-1.5 h-1.5 rounded-full bg-[#2f9e6c] mr-1" />Done 28%</span>
        <span><span className="inline-block w-1.5 h-1.5 rounded-full bg-[#d4a356] mr-1" />In progress 44%</span>
        <span><span className="inline-block w-1.5 h-1.5 rounded-full bg-[#ece8df] mr-1" />Open 28%</span>
      </div>
    </div>
  </MockShell>
);
const ClientsMock: React.FC = () => {
  const clients = [
    { name: "AAFIYA CONSTR.", loc: "07 Delhi, INDIA", phone: "1234567890", gst: "07KEZPS1323K1ZN", c: "#3b82f6", trend: [3, 5, 4, 6, 8, 7, 9] },
    { name: "AK MEHTA", loc: "10 Bihar, INDIA", phone: null, gst: null, c: "#1d4ed8", trend: [2, 4, 3, 5, 4, 6, 5] },
    { name: "GST LEDGER", loc: "07 Delhi, INDIA", phone: null, gst: "07AAGCI5622K1ZF", c: "#d4a356", trend: [5, 4, 6, 7, 6, 8, 9] },
    { name: "H R KHAN", loc: "07 Delhi, INDIA", phone: null, gst: null, c: "#9333ea", trend: [1, 3, 2, 4, 5, 4, 6] },
    { name: "JIYA", loc: "07 Delhi, INDIA", phone: "1234567890", gst: "07KEZPS1323K1ZN", c: "#16a34a", trend: [4, 6, 5, 7, 8, 9, 10] },
    { name: "JIYA EXPRESS", loc: "07 Delhi, INDIA", phone: "1234569870", gst: "07KEZPS1323K1ZN", c: "#16a34a", trend: [3, 4, 5, 6, 5, 7, 8] },
    { name: "MEDIFORD HEAL.", loc: "06 Haryana, INDIA", phone: null, gst: "06CZEPR4425H1ZA", c: "#1e3a8a", trend: [2, 3, 4, 3, 5, 6, 5] },
    { name: "TDS RECEIVABLE", loc: "Other, INDIA", phone: null, gst: null, c: "#e11d48", trend: [4, 5, 4, 6, 5, 7, 6] },
    { name: "NIKAT FOODS", loc: "07 Delhi, INDIA", phone: "9988776655", gst: "07NKTFD8821K1ZN", c: "#0ea5e9", trend: [3, 5, 6, 7, 8, 9, 11] },
    { name: "STARLINE LTD", loc: "12 Karnataka, INDIA", phone: "9001234567", gst: "29STRLN5612K1ZK", c: "#f97316", trend: [6, 7, 5, 8, 9, 10, 12] },
    { name: "VEGA EXPORTS", loc: "27 Maharashtra, INDIA", phone: null, gst: "27VEGEX1234K1ZM", c: "#a855f7", trend: [2, 4, 6, 5, 7, 8, 9] },
    { name: "ASHOK & CO.", loc: "08 Rajasthan, INDIA", phone: "9123456780", gst: null, c: "#0d9488", trend: [3, 4, 4, 5, 6, 7, 8] },
  ];
  return (
    <MockShell
      menu="Tasks"
      eyebrow="IV. DIRECTORY"
      title={<>Client <span style={{ fontStyle: "italic" }}>Management</span></>}
      right={
        <>
          <Pill>↑ Import</Pill>
          <Pill tone="dark">+ Add Client</Pill>
        </>
      }
    >
      <div className="grid grid-cols-4 gap-1.5 mb-1.5">
        {[
          { l: "Total Clients", v: 12, c: "#0f2d1f" },
          { l: "Active", v: 9, c: "#2f9e6c" },
          { l: "GST Registered", v: 8, c: "#d4a356" },
          { l: "New This Month", v: 3, c: "#1e3a8a" },
        ].map((s, i) => (
          <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 flex items-center gap-2 lp-soft-hover lp-mock-fade" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="w-6 h-6 rounded-md flex items-center justify-center text-[8px]" style={{ background: s.c + "22", color: s.c }}>●</div>
            <div>
              <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>{s.l}</div>
              <div className="lp-serif lp-mock-num" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "16px", fontWeight: 500, lineHeight: 1, letterSpacing: "-0.02em", color: s.c, animationDelay: `${i * 80 + 200}ms` }}>
                {s.v}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-[#fbf8f1] border border-[#e8e3d8] rounded-md px-2.5 py-1.5 mb-1.5 flex items-center gap-2 text-[9px] text-[#8a8580] lp-mock-fade" style={{ animationDelay: "320ms" }}>
        <span className="w-2 h-2 rounded-full border border-[#8a8580]" />
        Search by name, email, phone…
        <span className="ml-auto lp-mono text-[7px] text-[#0f2d1f]">⌘K</span>
      </div>
      <div className="lp-mock-stagger grid grid-cols-4 gap-1.5">
        {clients.map((c, i) => {
          const max = Math.max(...c.trend);
          const sparkPoints = c.trend.map((v, j) => `${(j / (c.trend.length - 1)) * 36},${12 - (v / max) * 12}`).join(" ");
          return (
            <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md overflow-hidden lp-soft-hover">
              <div className="h-0.5" style={{ background: c.c }} />
              <div className="p-1.5">
                <div className="flex items-center gap-1 mb-1">
                  <div className="w-5 h-5 rounded-md text-white flex items-center justify-center text-[8px] font-bold" style={{ background: c.c }}>
                    {c.name[0]}
                  </div>
                  <div className="text-[8px] font-semibold text-[#1a1a1a] truncate flex-1 uppercase tracking-wide">{c.name}</div>
                </div>
                <div className="text-[7px] text-[#4a4a4a] truncate">{c.loc}</div>
                <div className="flex items-center gap-1 text-[7px] text-[#8a8580] mt-0.5">
                  <span>📞</span>
                  <span className="truncate">{c.phone || "None"}</span>
                </div>
                <div className="flex items-center justify-between mt-1">
                  {c.gst ? (
                    <div className="text-[6px] text-[#854d0e] bg-[#fef3c7] rounded px-1 py-0.5 truncate flex-1 mr-1" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                      GST: {c.gst}
                    </div>
                  ) : (
                    <div className="text-[6px] text-[#8a8580] bg-[#f4f1ea] rounded px-1 py-0.5 flex-1 mr-1">No GST</div>
                  )}
                  <svg width="36" height="12" viewBox="0 0 36 12" className="shrink-0">
                    <polyline points={sparkPoints} fill="none" stroke={c.c} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="flex items-center justify-between pt-1 mt-1 border-t border-dashed border-[#d6d0c2] text-[7px]">
                  <span className="text-[#4a4a4a]">View</span>
                  <span className="text-[#4a4a4a]">Edit</span>
                  <span style={{ color: "#c4574c" }}>Delete</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </MockShell>
  );
};

// Full dashboard preview (large) — matches the actual /dashboard page
const DashboardFullMock: React.FC = () => {
  const presence = [60, 45, 78, 52, 88, 70, 0];
  const presenceMax = Math.max(...presence, 1);
  return (
    <div className="w-full h-full bg-[#faf8f3] flex" style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      {/* Sidebar */}
      <aside className="w-[120px] sm:w-[150px] shrink-0 bg-[#fbf8f1] border-r border-[#e8e3d8] py-3 px-2.5 flex flex-col gap-0.5">
        <div className="flex items-center gap-1 px-1.5 mb-2">
          <span className="text-[8px] tracking-[0.22em] uppercase text-[#8a8580] font-semibold">Menu</span>
          <span className="ml-auto text-[10px] text-[#8a8580]">«</span>
        </div>
        {[
          { l: "Dashboard", active: true },
          { l: "Employees" },
          { l: "Attendance" },
          { l: "Leaves" },
          { l: "Task Mgmt" },
          { l: "Work Monitor" },
          { l: "Payroll" },
          { l: "Downloads" },
          { l: "Separation" },
        ].map((item) => (
          <div
            key={item.l}
            className={`text-[9px] py-1.5 px-2 rounded-md ${item.active ? "bg-[#e8efe9] text-[#0f2d1f] font-semibold" : "text-[#4a4a4a]"}`}
          >
            {item.l}
          </div>
        ))}
      </aside>

      {/* Main */}
      <div className="flex-1 min-w-0 p-3.5 sm:p-4 flex flex-col gap-3 overflow-hidden">
        {/* Welcome header */}
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "8px" }}>I. WORKSPACE</div>
            <div
              className="lp-serif text-[#0f2d1f]"
              style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "clamp(18px, 2.2vw, 26px)", fontWeight: 500, letterSpacing: "-0.02em", lineHeight: 1.1 }}
            >
              Good Afternoon, <span style={{ fontStyle: "italic", color: "#0f2d1f" }}>Azmat</span>
            </div>
            <div className="text-[9px] text-[#8a8580] mt-0.5">Here's what's happening with your <span className="lp-serif" style={{ fontFamily: "'Fraunces', Georgia, serif", fontStyle: "italic" }}>organization</span> today.</div>
          </div>
          <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-lg px-2.5 py-1.5 shrink-0 flex items-center gap-2">
            <div>
              <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>Today's date</div>
              <div className="lp-serif text-[#0f2d1f]" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "10px", fontWeight: 500 }}>Saturday, May 9</div>
            </div>
            <span className="w-1.5 h-1.5 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
          </div>
        </div>

        {/* KPI tiles */}
        <div className="lp-mock-stagger grid grid-cols-4 gap-1.5">
          {[
            { l: "Total Employees", v: "20", s: "20 active", c: "#0f2d1f", bg: "#e8efe9" },
            { l: "Pending Leaves", v: "0", s: "Requires approval", c: "#854d0e", bg: "#fef3c7" },
            { l: "Today's Attendance", v: "0", s: "Present today", c: "#0f2d1f", bg: "#e8efe9" },
            { l: "Active Tasks", v: "5", s: "0 completed", c: "#1e3a8a", bg: "#dbeafe" },
          ].map((k, i) => (
            <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-soft-hover">
              <div className="flex items-start justify-between mb-1">
                <span className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>{k.l}</span>
                <span className="w-4 h-4 rounded flex items-center justify-center text-[7px]" style={{ background: k.bg, color: k.c }}>•</span>
              </div>
              <div className="lp-serif lp-mock-num" style={{ fontFamily: "'Fraunces', Georgia, serif", color: k.c, fontSize: "20px", fontWeight: 500, lineHeight: 1, letterSpacing: "-0.02em", animationDelay: `${i * 90 + 200}ms` }}>
                {k.v}
              </div>
              <div className="text-[7px] text-[#8a8580] mt-1">{k.s}</div>
            </div>
          ))}
        </div>

        {/* Insights row — bars + donut */}
        <div className="flex items-center gap-1.5 mt-1">
          <span className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>II. INSIGHTS</span>
          <span className="lp-serif text-[#0f2d1f]" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "11px", fontWeight: 500, letterSpacing: "-0.01em" }}>
            A live <span style={{ fontStyle: "italic" }}>read</span>
          </span>
          <span className="ml-auto inline-flex items-center gap-1 text-[7px]" style={{ color: "#2f9e6c" }}>
            <span className="w-1 h-1 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
            LIVE
          </span>
        </div>

        <div className="grid grid-cols-2 gap-1.5">
          {/* Daily presence bar chart */}
          <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2.5 lp-soft-hover">
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>ATTENDANCE · 7 DAYS</div>
                <div className="lp-serif text-[#0f2d1f]" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "11px", fontWeight: 500 }}>
                  Daily <span style={{ fontStyle: "italic" }}>presence</span>
                </div>
              </div>
              <div className="text-right">
                <div className="lp-serif" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "16px", fontWeight: 500, color: "#0f2d1f", lineHeight: 1, letterSpacing: "-0.02em" }}>
                  393
                </div>
                <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "6px", marginTop: "1px" }}>this week</div>
              </div>
            </div>
            <div className="flex items-end gap-1 h-9">
              {presence.map((v, i) => {
                const pct = (v / presenceMax) * 100;
                return (
                  <div key={i} className="flex-1 flex flex-col items-center gap-0.5">
                    <div className="text-[6px] text-[#8a8580] font-semibold">{v}</div>
                    <div className="w-full flex-1 bg-[#ece8df] rounded-sm flex items-end overflow-hidden">
                      <div
                        className="w-full rounded-sm bg-[#0f2d1f] lp-mock-bar-y"
                        style={{ height: `${pct}%`, ["--h" as any]: `${pct}%`, animationDelay: `${300 + i * 70}ms` }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="grid grid-cols-7 gap-1 mt-1">
              {["S", "M", "T", "W", "T", "F", "S"].map((d, i) => (
                <div key={i} className="text-[6px] text-center text-[#8a8580] tracking-wider uppercase">{d}</div>
              ))}
            </div>
          </div>

          {/* Tasks by priority — donut */}
          <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2.5 lp-soft-hover flex">
            <div className="flex-1">
              <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>TASKS · BY PRIORITY</div>
              <div className="lp-serif text-[#0f2d1f] mb-2" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "11px", fontWeight: 500 }}>
                Where <span style={{ fontStyle: "italic" }}>focus</span> lives
              </div>
              <div className="flex items-center gap-2.5">
                <div className="relative w-12 h-12 shrink-0">
                  <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
                    <circle cx="18" cy="18" r="15.5" fill="none" stroke="#ece8df" strokeWidth="4" />
                    <circle cx="18" cy="18" r="15.5" fill="none" stroke="#dc2626" strokeWidth="4" strokeDasharray="19.5 80" strokeLinecap="butt" pathLength={100} className="lp-mock-draw" style={{ ["--c" as any]: 100, ["--off" as any]: 0, animationDelay: "400ms" }} />
                    <circle cx="18" cy="18" r="15.5" fill="none" stroke="#d97706" strokeWidth="4" strokeDasharray="78 80" strokeDashoffset="-19.5" strokeLinecap="butt" pathLength={100} className="lp-mock-draw" style={{ ["--c" as any]: 100, ["--off" as any]: -19.5, animationDelay: "700ms" }} />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <div className="lp-serif text-[#0f2d1f]" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "11px", fontWeight: 500, lineHeight: 1 }}>5</div>
                    <div className="text-[5px] tracking-wider text-[#8a8580]">OPEN</div>
                  </div>
                </div>
                <div className="flex-1 space-y-0.5 text-[7px]">
                  {[
                    { l: "Urgent", c: "#dc2626", v: 1 },
                    { l: "High", c: "#ea580c", v: 0 },
                    { l: "Medium", c: "#d97706", v: 4 },
                    { l: "Low", c: "#2563eb", v: 0 },
                  ].map((s, i) => (
                    <div key={i} className="flex items-center gap-1">
                      <span className="w-1 h-1 rounded-full" style={{ background: s.c }} />
                      <span className="text-[#4a4a4a] flex-1">{s.l}</span>
                      <span className="font-semibold text-[#1a1a1a]">{s.v}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modules strip */}
        <div className="lp-mock-stagger grid grid-cols-4 gap-1.5">
          {[
            { n: "01", t: "Employees", s: "20 / 18 active" },
            { n: "02", t: "Attendance", s: "0 / 0% rate" },
            { n: "03", t: "Leaves", s: "0 / 0 approved" },
            { n: "04", t: "Tasks", s: "5 / 0 done" },
          ].map((m, i) => (
            <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-1.5 lp-soft-hover">
              <div className="flex items-start justify-between">
                <span className="lp-mono text-[#8a8580]" style={{ fontSize: "6px", letterSpacing: "0.18em" }}>№ {m.n}</span>
                <span className="w-3 h-3 rounded-full bg-[#e8efe9]" />
              </div>
              <div className="lp-serif text-[#0f2d1f] mt-0.5" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "9px", fontWeight: 500 }}>{m.t}</div>
              <div className="text-[6px] text-[#0f2d1f] mt-1 lp-mono tracking-wider uppercase">{m.s}</div>
            </div>
          ))}
        </div>

        {/* Live activity feed — fills remaining space */}
        <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md p-2 lp-mock-fade" style={{ animationDelay: "900ms" }}>
          <div className="flex items-center gap-1.5 mb-1.5">
            <span className="w-1 h-1 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
            <span className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "7px" }}>TODAY'S ACTIVITY</span>
            <span className="ml-auto lp-mono text-[6px] text-[#0f2d1f] tracking-wider uppercase">3 just now</span>
          </div>
          <div className="lp-mock-stagger grid grid-cols-3 gap-1.5">
            {[
              { who: "Priya S.", what: "Clocked in", at: "9:02", c: "#2f9e6c", ic: "→" },
              { who: "Arjun M.", what: "Applied leave", at: "9:14", c: "#d4a356", ic: "★" },
              { who: "Kavya R.", what: "Closed task", at: "9:21", c: "#0f2d1f", ic: "✓" },
            ].map((a, i) => (
              <div key={i} className="flex items-center gap-1.5 bg-[#fbf8f1] border border-[#e8e3d8] rounded px-1.5 py-1">
                <div className="w-4 h-4 rounded-full text-white flex items-center justify-center text-[7px]" style={{ background: a.c }}>{a.ic}</div>
                <div className="flex-1 min-w-0">
                  <div className="text-[7px] font-semibold text-[#1a1a1a] truncate">{a.who} <span className="text-[#4a4a4a] font-normal">· {a.what}</span></div>
                  <div className="lp-mono text-[6px] text-[#8a8580]">{a.at} AM</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
/* ──────────────── /Tour mock dashboards ──────────────── */

const LandingPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeTour, setActiveTour] = useState(0);
  const [tourPaused, setTourPaused] = useState(false);
  const [tourTick, setTourTick] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);
  const [slidePaused, setSlidePaused] = useState(false);
  const [slideTick, setSlideTick] = useState(0);
  // Login flow states
  const [loginStep, setLoginStep] = useState<"email" | "organizations" | "login">("email");
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null);
  const [loginEmail, setLoginEmail] = useState("");

  const navigate = useNavigate();
  const { toast } = useToast();
  const { loginSelect, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user]);

  const { register, handleSubmit, getValues } = useForm<LoginForm>();

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Employee Directory",
      description:
        "Avatar-rich profiles, role and department filters, bulk CSV import. Onboard a 200-person team in a single afternoon.",
      tags: ["Bulk import", "Role-gated"],
    },
    {
      icon: <FaUserClock />,
      title: "GPS Attendance",
      description:
        "Clock-ins verified by GPS, geofence, and selfie — from app, web, or WhatsApp. Late-marks calculated automatically.",
      tags: ["GPS · Geofence", "WhatsApp"],
    },
    {
      icon: <FaCalculator />,
      title: "Payroll Engine",
      description:
        "Salary components, tax slabs, deductions, and approval workflows in one place. Bulk-run payroll, generate payslips, file with confidence.",
      tags: ["EPF · ESI · TDS", "Approvals"],
    },
    {
      icon: <FaShieldAlt />,
      title: "Leaves & Approvals",
      description:
        "Configure leave types, approval chains, and balance accruals. Employees apply in seconds — managers approve in one tap.",
      tags: ["6 leave types", "Multi-step"],
    },
    {
      icon: <FaChartLine />,
      title: "Tasks & Projects",
      description:
        "Daily planner, kanban projects, client folders, and reports — the work alongside the workforce, not in a separate tool.",
      tags: ["Kanban", "Client work"],
    },
    {
      icon: <FaMobileAlt />,
      title: "Work Monitor",
      description:
        "Activity reports, periodic screenshots, cross-employee comparison. Trust, but verify — without micromanaging.",
      tags: ["Activity", "Comparison"],
    },
  ];

  const capabilities = [
    { icon: <FaSync />, title: "Reports & Analytics", body: "Completion health, workload spread, per-client breakdowns." },
    { icon: <FaBuilding />, title: "Separation Mgmt", body: "Resignations, exit checklists, full & final settlements." },
    { icon: <FaCheckCircle />, title: "Documents & Letters", body: "Offer letters, policies, signed documents — version-controlled." },
    { icon: <FaRobot />, title: "AI Assist", body: "Smart suggestions across reviews, leaves, and reconciliation." },
  ];

  const stats = [
    { value: "10,000+", label: "Happy Companies" },
    { value: "₹399", label: "Starting Price/Month" },
    { value: "99.9%", label: "Uptime" },
    { value: "24/7", label: "Support" },
  ];

  // Step 1: Get organizations by email
  const handleGetOrganizations = async (data: LoginForm) => {
    try {
      console.log("LandingPage: Getting organizations for email:", data.email);
      setLoading(true);
      setLoginEmail(data.email);

      const response = await getOrganizations(data.email);
      console.log("LandingPage: Organizations response:", response);

      if (response.success && response.organizations && response.organizations.length > 0) {
        setOrganizations(response.organizations);

        // If only one organization, auto-select it and go to login
        if (response.organizations.length === 1) {
          const singleOrg = response.organizations[0];
          setSelectedOrg(singleOrg);
          setLoginStep("login");
          toast({
            title: "Success",
            description: `Logged in to ${singleOrg.company_name}`,
          });
        } else {
          // Multiple organizations - show selection screen
          setLoginStep("organizations");
          toast({
            title: "Success",
            description: `Found ${response.organizations.length} organizations. Please select one.`,
          });
        }
      } else {
        toast({
          // title: "Error",
          description: "No organizations found for this email",
          variant: "destructive",
        });
      }
    } catch (error: any) {
      console.error("LandingPage: Error getting organizations:", error);
      toast({
        // title: "Error",
        description: error.message || "Failed to fetch organizations",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Select organization (only shown when multiple organizations exist)
  const handleSelectOrganization = (org: Organization) => {
    setSelectedOrg(org);
    setLoginStep("login");
  };

  // Step 3: Complete login with email, password, and head_office_id
  const handleCompleteLogin = async (data: LoginForm) => {
    if (!selectedOrg) {
      toast({
        // title: "Error",
        description: "Please select an organization first",
        variant: "destructive",
      });
      return;
    }

    try {
      console.log("LandingPage: Completing login with organization:", selectedOrg.head_office_id);
      setLoading(true);

      // Call login with email, password, and head_office_id
      await loginSelect(loginEmail, data.password, selectedOrg.head_office_id);

      toast({
        title: "Success",
        description: `Logged in to ${selectedOrg.company_name} successfully`,
      });

      navigate("/dashboard");
    } catch (error: any) {
      console.error("LandingPage: Login error occurred:", error);
      toast({
        variant: "destructive",
        // title: "Error",
        description: error.message || "Invalid credentials",
      });
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data: LoginForm) => {
    if (loginStep === "email") {
      await handleGetOrganizations(data);
    } else if (loginStep === "login") {
      await handleCompleteLogin(data);
    }
  };

  const handleBackToEmail = () => {
    setLoginStep("email");
    setOrganizations([]);
    setSelectedOrg(null);
  };

  const handleBackToOrganizations = () => {
    setLoginStep("organizations");
    setSelectedOrg(null);
  };

  useEffect(() => {
    if (tourPaused) return;
    const interval = setInterval(() => {
      setActiveTour((prev) => (prev + 1) % 6);
      setTourTick((t) => t + 1);
    }, 3800);
    return () => clearInterval(interval);
  }, [tourPaused, activeTour]);

  // Hero slide auto-advance
  useEffect(() => {
    if (slidePaused) return;
    const interval = setInterval(() => {
      setActiveSlide((p) => (p + 1) % 4);
      setSlideTick((t) => t + 1);
    }, 6500);
    return () => clearInterval(interval);
  }, [slidePaused, activeSlide]);

  // Scroll-reveal observer — adds `is-revealed` to .lp-reveal elements when they enter the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    const els = document.querySelectorAll(".lp-reveal");
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const heroSlides = [
    {
      eyebrow: "★ New · Now in beta",
      eyebrowB: "Free with every plan",
      headline: (
        <>
          Get your first
          <br />
          <span style={{ fontStyle: "italic", color: "#1f4030" }}>AI employee</span>, with Teamlio.
        </>
      ),
      sub: "Always on, always learning, never asks for leave. Ask questions, draft messages, summarise reports — your team's quietest, fastest hire. Now bundled into every Teamlio plan.",
      cta: "Hire your AI",
    },
    {
      eyebrow: "Volume 01 — Spring 2026",
      eyebrowB: "For modern HR teams",
      headline: (
        <>
          Run payroll like a{" "}
          <span style={{ fontStyle: "italic", color: "#1f4030" }}>quiet,</span>
          <br />
          well-tuned <span style={{ fontStyle: "italic" }}>machine.</span>
        </>
      ),
      sub: "Teamlio is the operating system for India's modern HR team. GPS-verified attendance, automated salary runs, AI insights — all in one calmly-designed workspace your finance team will actually thank you for.",
      cta: "Start your free trial",
    },
    {
      eyebrow: "Chapter 02 — Attendance",
      eyebrowB: "Wherever your team works",
      headline: (
        <>
          Attendance, <span style={{ fontStyle: "italic", color: "#1f4030" }}>automated.</span>
          <br />
          Anywhere your <span style={{ fontStyle: "italic" }}>team</span> is.
        </>
      ),
      sub: "GPS, geofencing, and selfie-verified clock-ins via mobile, web, or WhatsApp — no more shared sheets, no more arguments at the end of the month.",
      cta: "See how it works",
    },
    {
      eyebrow: "Chapter 03 — Insights",
      eyebrowB: "Numbers that read themselves",
      headline: (
        <>
          AI insights your <span style={{ fontStyle: "italic", color: "#1f4030" }}>CFO</span>
          <br />
          will <span style={{ fontStyle: "italic" }}>actually</span> read.
        </>
      ),
      sub: "Workforce productivity, payroll trends, and reconciliation flags — distilled into the one paragraph your leadership needs each Monday morning.",
      cta: "Tour the reports",
    },
  ];

  const tourModules = [
    {
      eyebrow: "I. Workspace",
      title: "Your morning briefing",
      desc: "One screen with live attendance, payroll preview, task health, and quick links to every module.",
      img: "/screenshots/dashboard.png",
      tag: "Dashboard",
    },
    {
      eyebrow: "II. People",
      title: "Employee directory",
      desc: "Avatar-rich cards, role and department filters, and one-click import from spreadsheets.",
      img: "/screenshots/employees.png",
      tag: "Employees",
    },
    {
      eyebrow: "III. Operations",
      title: "Attendance, accounted for",
      desc: "Live present/absent counts, attendance rate, and date-range filters with employee search.",
      img: "/screenshots/attendance.png",
      tag: "Attendance",
    },
    {
      eyebrow: "I. Today",
      title: "A planner that thinks ahead",
      desc: "Today / Upcoming / Missed lanes, priority flags, reminders, and one-tap completion.",
      img: "/screenshots/planner.png",
      tag: "Planner",
    },
    {
      eyebrow: "III. Insights",
      title: "Reports without the spreadsheet",
      desc: "Completion health, workload spread, and per-client breakdowns — ready for the Monday meeting.",
      img: "/screenshots/reports.png",
      tag: "Reports",
    },
    {
      eyebrow: "IV. Directory",
      title: "Client management",
      desc: "Colour-coded client cards, GST badges, search, and one-tap actions — every client and account in one tidy directory.",
      img: "/screenshots/clients.png",
      tag: "Clients",
    },
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#faf8f3] text-[#1a1a1a] overflow-x-hidden">
      <style>{`
        @keyframes lp-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes lp-fade-up { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes lp-pulse-dot { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }
        @keyframes lp-float { 0%,100% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-8px) rotate(0.2deg); } }
        @keyframes lp-tour-progress { from { width: 0%; } to { width: 100%; } }
        @keyframes lp-tour-zoom { from { opacity: 0; transform: scale(1.04); } to { opacity: 1; transform: scale(1); } }
        @keyframes lp-shimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(220%); } }
        .lp-marquee { animation: lp-marquee 38s linear infinite; }
        .lp-fade { animation: lp-fade-up 0.85s cubic-bezier(0.33, 1, 0.68, 1) backwards; }
        .lp-pulse-dot { animation: lp-pulse-dot 1.6s ease-in-out infinite; }
        .lp-float { animation: lp-float 7s ease-in-out infinite; }
        .lp-tour-tab { transition: all 320ms cubic-bezier(0.33, 1, 0.68, 1); }
        .lp-tour-tab .lp-tour-bar { width: 0%; transition: none; }
        .lp-tour-tab.is-active .lp-tour-bar { animation: lp-tour-progress 3800ms linear forwards; }
        .lp-tour-frame { transition: transform 700ms cubic-bezier(0.33, 1, 0.68, 1), box-shadow 700ms; }
        .lp-tour-frame:hover { transform: translateY(-6px); }
        .lp-tour-img { animation: lp-tour-zoom 0.9s cubic-bezier(0.4, 0, 0.2, 1) both; }
        .lp-shimmer::after {
          content: "";
          position: absolute; inset: 0;
          background: linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%);
          transform: translateX(-100%);
          animation: lp-shimmer 2.4s cubic-bezier(0.4, 0, 0.2, 1) infinite;
          pointer-events: none;
        }
        html { scroll-behavior: smooth; }
        @media (prefers-reduced-motion: reduce) { html { scroll-behavior: auto; } }
        .lp-reveal {
          opacity: 0;
          transform: translateY(28px);
          transition: opacity 900ms cubic-bezier(0.22, 1, 0.36, 1), transform 900ms cubic-bezier(0.22, 1, 0.36, 1);
          will-change: opacity, transform;
        }
        .lp-reveal.is-revealed { opacity: 1; transform: translateY(0); }
        .lp-stagger > * {
          opacity: 0;
          transform: translateY(22px);
          transition: opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .lp-stagger.is-revealed > * { opacity: 1; transform: translateY(0); }
        .lp-stagger.is-revealed > *:nth-child(1)  { transition-delay: 0ms; }
        .lp-stagger.is-revealed > *:nth-child(2)  { transition-delay: 90ms; }
        .lp-stagger.is-revealed > *:nth-child(3)  { transition-delay: 180ms; }
        .lp-stagger.is-revealed > *:nth-child(4)  { transition-delay: 270ms; }
        .lp-stagger.is-revealed > *:nth-child(5)  { transition-delay: 360ms; }
        .lp-stagger.is-revealed > *:nth-child(6)  { transition-delay: 450ms; }
        .lp-stagger.is-revealed > *:nth-child(7)  { transition-delay: 540ms; }
        .lp-stagger.is-revealed > *:nth-child(8)  { transition-delay: 630ms; }
        .lp-mock-stage > .lp-mock-pane {
          transition: opacity 800ms cubic-bezier(0.4, 0, 0.2, 1), transform 1100ms cubic-bezier(0.22, 1, 0.36, 1), filter 800ms;
        }
        .lp-mock-stage > .lp-mock-pane.is-leaving { transform: translateX(-3%) scale(0.98); filter: blur(2px); }
        .lp-mock-stage > .lp-mock-pane.is-entering { transform: translateX(3%) scale(0.98); filter: blur(2px); }
        .lp-mock-stage > .lp-mock-pane.is-active-pane { transform: translateX(0) scale(1); filter: blur(0); }
        .lp-soft-hover { transition: transform 280ms cubic-bezier(0.33, 1, 0.68, 1), box-shadow 280ms; }
        .lp-soft-hover:hover { transform: translateY(-3px); }
        .lp-num-tab {
          font-variant-numeric: tabular-nums lining-nums;
          font-feature-settings: 'tnum' 1, 'lnum' 1;
        }
        @keyframes lp-slide-in-up {
          0% { opacity: 0; transform: translateY(36px); filter: blur(4px); }
          100% { opacity: 1; transform: translateY(0); filter: blur(0); }
        }
        @keyframes lp-mock-grow-y { from { height: 0%; } to { height: var(--h, 100%); } }
        @keyframes lp-mock-grow-x { from { width: 0%; } to { width: var(--w, 100%); } }
        @keyframes lp-mock-fade-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes lp-mock-draw { from { stroke-dashoffset: var(--c, 100); } to { stroke-dashoffset: var(--off, 0); } }
        @keyframes lp-mock-count { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }
        .lp-mock-bar-y { animation: lp-mock-grow-y 1100ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-mock-bar-x { animation: lp-mock-grow-x 1100ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-mock-fade { animation: lp-mock-fade-in 700ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-mock-num { animation: lp-mock-count 700ms cubic-bezier(0.22, 1, 0.36, 1) backwards; display: inline-block; }
        .lp-mock-stagger > * { animation: lp-mock-fade-in 700ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-mock-stagger > *:nth-child(1) { animation-delay: 50ms; }
        .lp-mock-stagger > *:nth-child(2) { animation-delay: 130ms; }
        .lp-mock-stagger > *:nth-child(3) { animation-delay: 210ms; }
        .lp-mock-stagger > *:nth-child(4) { animation-delay: 290ms; }
        .lp-mock-stagger > *:nth-child(5) { animation-delay: 370ms; }
        .lp-mock-stagger > *:nth-child(6) { animation-delay: 450ms; }
        .lp-mock-stagger > *:nth-child(7) { animation-delay: 530ms; }
        .lp-mock-stagger > *:nth-child(8) { animation-delay: 610ms; }
        .lp-mock-stagger > *:nth-child(9) { animation-delay: 690ms; }
        .lp-mock-stagger > *:nth-child(10) { animation-delay: 770ms; }
        .lp-mock-stagger > *:nth-child(11) { animation-delay: 850ms; }
        .lp-mock-stagger > *:nth-child(12) { animation-delay: 930ms; }
        .lp-mock-draw { animation: lp-mock-draw 1400ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-slide-pane { transition: opacity 900ms cubic-bezier(0.22, 1, 0.36, 1); }
        .lp-slide-pane.is-active > * { animation: lp-slide-in-up 1100ms cubic-bezier(0.22, 1, 0.36, 1) backwards; }
        .lp-slide-pane.is-active > *:nth-child(1) { animation-delay: 80ms; }
        .lp-slide-pane.is-active > *:nth-child(2) { animation-delay: 220ms; }
        .lp-slide-pane.is-active > *:nth-child(3) { animation-delay: 380ms; }
        .lp-slide-pane.is-active > *:nth-child(4) { animation-delay: 520ms; }
        .lp-slide-pane.is-active > *:nth-child(5) { animation-delay: 660ms; }
        .lp-slide-bar { transition: width 6500ms linear, opacity 300ms; }
        .lp-slide-dot { transition: all 320ms cubic-bezier(0.33, 1, 0.68, 1); }
        @media (prefers-reduced-motion: reduce) {
          .lp-marquee, .lp-fade, .lp-pulse-dot, .lp-float, .lp-tour-img,
          .lp-tour-tab.is-active .lp-tour-bar, .lp-shimmer::after,
          .lp-reveal, .lp-stagger > *, .lp-mock-stage > .lp-mock-pane,
          .lp-slide-pane.is-active > *, .lp-slide-bar {
            animation: none !important;
            transition: none !important;
            opacity: 1 !important;
            transform: none !important;
            filter: none !important;
          }
        }
        .lp-grain {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.05 0'/></filter><rect width='240' height='240' filter='url(%23n)'/></svg>");
        }
        .lp-serif, .lp-serif * { font-family: 'Fraunces', 'Iowan Old Style', Georgia, serif !important; font-feature-settings: 'tnum' 1, 'lnum' 1, 'ss01' 1; }
        .lp-mono { font-family: 'JetBrains Mono', ui-monospace, monospace !important; }
        .lp-eyebrow {
          font-family: 'JetBrains Mono', ui-monospace, monospace;
          font-size: 11px;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          font-weight: 500;
        }
        .lp-dotted-h {
          background-image: radial-gradient(circle, currentColor 1px, transparent 1.2px);
          background-size: 8px 8px;
          background-position: 0 50%;
          background-repeat: repeat-x;
        }
        .lp-press { transition: transform 200ms cubic-bezier(0.33, 1, 0.68, 1), background 200ms; }
        .lp-press:hover { transform: translateY(-2px); }
        .lp-press:active { transform: translateY(0); }
        .lp-feature-card { transition: transform 420ms cubic-bezier(0.33, 1, 0.68, 1), border-color 280ms, background 280ms, box-shadow 420ms; }
        .lp-feature-card:hover { transform: translateY(-6px); border-color: #0f2d1f; background: #fbf8f1; box-shadow: 0 24px 48px -16px rgba(15,45,31,0.18), 0 4px 10px -4px rgba(15,45,31,0.06); }
        .lp-feature-glow { position: relative; }
        .lp-link-arrow { transition: transform 240ms cubic-bezier(0.33, 1, 0.68, 1); }
        .group:hover .lp-link-arrow, a:hover .lp-link-arrow, button:hover .lp-link-arrow { transform: translateX(4px); }
        .lp-input { background: transparent; border: 0; border-bottom: 2px solid #d6d0c2; outline: none; transition: border-color 200ms; font-family: 'Fraunces', Georgia, serif; font-size: 22px; color: #0f2d1f; padding: 10px 0; width: 100%; }
        .lp-input::placeholder { color: #b8b3ac; font-style: italic; }
        .lp-input:focus { border-bottom-color: #0f2d1f; }
      `}</style>

      {/* Announcement marquee */}
      <div className="bg-[#0f2d1f] text-[#faf8f3] py-2.5 overflow-hidden border-b border-[#1f4030]">
        <div className="flex whitespace-nowrap lp-marquee lp-mono text-[11px] tracking-[0.18em] uppercase">
          {[0, 1].map((k) => (
            <div key={k} className="flex items-center gap-12 pr-12 shrink-0">
              <span style={{ color: "#d4a356" }}>★ NEW · Get your first AI employee — free with every plan</span>
              <span className="opacity-40">✦</span>
              <span className="opacity-90">Free 30-day trial · No credit card</span>
              <span className="opacity-40">✦</span>
              <span className="opacity-90">10,000+ companies on board</span>
              <span className="opacity-40">✦</span>
              <span className="opacity-90">EPF · ESI · TDS compliant</span>
              <span className="opacity-40">✦</span>
              <span className="opacity-90">99.9% uptime guarantee</span>
              <span className="opacity-40">✦</span>
              <span className="opacity-90">Now live: WhatsApp payslips</span>
              <span className="opacity-40">✦</span>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation */}
      <nav className="sticky top-0 left-0 w-full bg-[#faf8f3]/85 backdrop-blur-md z-50 border-b border-[#e8e3d8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-16">
            <button onClick={() => scrollToSection("home")} className="flex items-center gap-3 group">
              <div className="relative">
                <div className="w-9 h-9 rounded-full bg-[#0f2d1f] flex items-center justify-center">
                  <FaUserClock className="text-[#faf8f3] text-base" />
                </div>
                <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#d4a356] border-2 border-[#faf8f3]"></span>
              </div>
              <div className="leading-tight text-left">
                <div className="lp-serif text-[20px] font-semibold tracking-tight text-[#0f2d1f] flex items-center gap-2">
                  Teamlio
                  <span className="lp-mono inline-flex items-center gap-1 bg-[#0f2d1f] text-[#d4a356] px-1.5 py-0.5 rounded-full" style={{ fontSize: "8px", letterSpacing: "0.16em" }}>
                    <FaRobot className="text-[8px]" /> AI
                  </span>
                </div>
                <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: '9px' }}>Est. 2024 · India</div>
              </div>
            </button>

            <div className="hidden md:flex items-center gap-1">
              {([
                ["Home", "home"],
                ["Features", "features"],
                ["How it works", "process"],
                ["Tour", "tour"],
                ["AI", "ai"],
                ["Pricing", "pricing"],
              ] as const).map(([label, id]) => (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="px-3 py-1.5 text-sm text-[#1a1a1a] hover:text-[#0f2d1f] hover:bg-[#ece8df] rounded-full transition-colors"
                >
                  {label}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => scrollToSection("login")}
                className="hidden sm:inline-block text-sm text-[#1a1a1a] hover:text-[#0f2d1f] px-3 py-1.5 transition-colors"
              >
                Sign in
              </button>
              <button
                onClick={() => scrollToSection("register")}
                className="hidden sm:inline-flex items-center gap-2 bg-[#0f2d1f] text-[#faf8f3] text-sm font-medium px-4 py-2 rounded-full lp-press hover:bg-[#0a1f15] group"
              >
                Start free trial
                <FaArrowRight className="text-xs lp-link-arrow" />
              </button>
              <button
                className="md:hidden p-2 text-[#0f2d1f]"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
              </button>
            </div>
          </div>

          {isMenuOpen && (
            <div className="md:hidden border-t border-[#e8e3d8] py-4 flex flex-col gap-1">
              {([
                ["Home", "home"],
                ["Features", "features"],
                ["How it works", "process"],
                ["Tour", "tour"],
                ["Pricing", "pricing"],
                ["Sign in", "login"],
              ] as const).map(([label, id]) => (
                <button
                  key={id}
                  onClick={() => scrollToSection(id)}
                  className="text-left px-3 py-2 text-sm hover:bg-[#ece8df] rounded-md text-[#1a1a1a]"
                >
                  {label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection("register")}
                className="mt-2 inline-flex items-center justify-center gap-2 bg-[#0f2d1f] text-[#faf8f3] text-sm font-medium px-4 py-2.5 rounded-full"
              >
                Start free trial <FaArrowRight className="text-xs" />
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* HERO */}
      <section id="home" className="relative pt-16 pb-24 lg:pt-24 lg:pb-32 px-6 lg:px-10 overflow-hidden">
        <div aria-hidden className="pointer-events-none absolute -top-48 -right-48 w-[640px] h-[640px] rounded-full bg-[#e8efe9] opacity-60" />
        <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#f4f1ea] opacity-90" />
        <div aria-hidden className="pointer-events-none absolute inset-0 lp-grain mix-blend-multiply opacity-40" />

        <div className="relative max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          {/* Editorial slide carousel */}
          <div
            className="lg:col-span-7 lp-fade relative"
            onMouseEnter={() => setSlidePaused(true)}
            onMouseLeave={() => setSlidePaused(false)}
          >
            <div className="relative" style={{ minHeight: "clamp(440px, 52vw, 560px)" }}>
              {heroSlides.map((slide, i) => {
                const isActive = i === activeSlide;
                return (
                  <div
                    key={`${i}-${slideTick}`}
                    className={`lp-slide-pane absolute inset-0 ${isActive ? "is-active opacity-100" : "opacity-0 pointer-events-none"}`}
                  >
                    <div className="flex items-center gap-4 mb-8 flex-wrap">
                      <span className="lp-eyebrow text-[#0f2d1f]">{slide.eyebrow}</span>
                      <span className="h-px w-12 bg-[#0f2d1f]/30" />
                      <span className="lp-eyebrow text-[#8a8580]">{slide.eyebrowB}</span>
                    </div>

                    <h1
                      className="lp-serif text-[#0f2d1f] mb-8"
                      style={{
                        fontFamily: "'Fraunces', Georgia, serif",
                        fontSize: "clamp(40px, 6.4vw, 76px)",
                        lineHeight: 0.98,
                        letterSpacing: "-0.025em",
                        fontWeight: 500,
                      }}
                    >
                      {slide.headline}
                    </h1>

                    <p className="text-[17px] leading-[1.65] text-[#4a4a4a] max-w-[560px] mb-10">
                      {slide.sub}
                    </p>

                    <div className="flex flex-wrap items-center gap-5">
                      <button
                        onClick={() => scrollToSection("register")}
                        className="inline-flex items-center gap-3 bg-[#0f2d1f] text-[#faf8f3] pl-6 pr-2 py-2 rounded-full font-medium lp-press hover:bg-[#0a1f15] group"
                      >
                        <span className="py-1.5">{slide.cta}</span>
                        <span className="w-9 h-9 rounded-full bg-[#1f4030] flex items-center justify-center lp-link-arrow">
                          <FaArrowRight className="text-xs" />
                        </span>
                      </button>
                      <button
                        onClick={() => scrollToSection("features")}
                        className="inline-flex items-center gap-2 text-[#0f2d1f] font-medium hover:text-[#1f4030] group"
                      >
                        <span className="border-b border-[#0f2d1f]/40 group-hover:border-[#0f2d1f] pb-0.5">
                          Read the chapter
                        </span>
                        <FaArrowRight className="text-xs lp-link-arrow" />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Slide controls — dot pagination + progress bar */}
            <div className="relative flex items-center gap-4 pt-6 flex-wrap">
              <div className="flex items-center gap-2.5">
                {heroSlides.map((_, i) => {
                  const isActive = i === activeSlide;
                  return (
                    <button
                      key={i}
                      onClick={() => {
                        setActiveSlide(i);
                        setSlideTick((t) => t + 1);
                      }}
                      className="lp-slide-dot group flex items-center"
                      aria-label={`Go to slide ${i + 1}`}
                    >
                      <span
                        className={`block rounded-full transition-all duration-500 ${
                          isActive ? "bg-[#0f2d1f] w-8 h-2" : "bg-[#d6d0c2] w-2 h-2 group-hover:bg-[#8a8580]"
                        }`}
                      />
                    </button>
                  );
                })}
              </div>
              <span className="lp-mono text-[10px] tracking-[0.2em] uppercase text-[#8a8580]">
                {String(activeSlide + 1).padStart(2, "0")} / {String(heroSlides.length).padStart(2, "0")}
              </span>
              <div className="flex-1 h-px bg-[#e8e3d8] relative overflow-hidden max-w-[180px] min-w-[80px]">
                <div
                  key={`bar-${slideTick}-${slidePaused ? "p" : "r"}`}
                  className="absolute left-0 top-0 h-full bg-[#0f2d1f]"
                  style={{
                    animation: slidePaused ? "none" : "lp-tour-progress 6500ms linear forwards",
                  }}
                />
              </div>

              <div className="hidden md:flex items-center gap-x-5 gap-y-2 ml-auto text-[12px] text-[#4a4a4a]">
                <div className="flex items-center gap-1.5">
                  <FaCheckCircle className="text-[#2f9e6c] text-[10px]" />
                  <span>30-day trial</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <FaCheckCircle className="text-[#2f9e6c] text-[10px]" />
                  <span>No credit card</span>
                </div>
              </div>
            </div>
          </div>

          {/* Dashboard mock */}
          <div className="lg:col-span-5 relative lp-fade lp-float" style={{ animationDelay: "0.18s" }}>
            <div className="absolute -top-4 -left-6 z-30 bg-[#faf8f3] border border-[#e8e3d8] rounded-2xl shadow-[0_18px_40px_-12px_rgba(15,45,31,0.18)] px-4 py-3 flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
              <div className="leading-tight">
                <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "9px" }}>Live</div>
                <div className="text-[13px] font-semibold text-[#0f2d1f]">142 clocked in</div>
              </div>
            </div>

            <div aria-hidden className="absolute inset-0 translate-x-3 translate-y-3 bg-[#0f2d1f] rounded-[24px]" />

            <div className="relative bg-[#faf8f3] border border-[#e8e3d8] rounded-[24px] overflow-hidden shadow-[0_28px_64px_-14px_rgba(15,45,31,0.18)]">
              <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#efeae0] bg-[#fbf8f1]">
                <div className="flex items-center gap-1.5">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#c4574c]/70" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#d4a356]/70" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#2f9e6c]/70" />
                </div>
                <span className="lp-mono text-[10px] text-[#8a8580]">teamlio.app/dashboard</span>
                <span className="w-6" />
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "10px" }}>Wednesday · 09 May</div>
                    <div className="lp-serif text-[22px] text-[#0f2d1f] font-medium leading-tight" style={{ fontFamily: "'Fraunces', Georgia, serif" }}>
                      Good morning, <span style={{ fontStyle: "italic" }}>Riya</span>
                    </div>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-[#e8efe9] border border-[#d4ddd6] flex items-center justify-center text-[#0f2d1f] text-sm font-semibold">RS</div>
                </div>

                <div className="rounded-2xl bg-[#0f2d1f] text-[#faf8f3] p-5 mb-5 relative overflow-hidden">
                  <div aria-hidden className="absolute -top-10 -right-10 w-36 h-36 rounded-full bg-[#1f4030] opacity-50" />
                  <div className="relative">
                    <div className="lp-eyebrow text-[#9eb3a4] mb-3" style={{ fontSize: "10px", color: "#9eb3a4" }}>Today's payroll preview</div>
                    <div className="lp-serif text-[40px] font-medium leading-none" style={{ fontFamily: "'Fraunces', Georgia, serif", color: "#faf8f3" }}>
                      ₹14,82,400
                    </div>
                    <div className="text-[12px] mt-2" style={{ color: "#9eb3a4" }}>Across 89 employees · ready to release</div>
                    <div className="mt-4 flex items-end gap-1.5 h-12">
                      {[60, 38, 72, 45, 88, 52, 95, 68, 41, 78, 56, 84].map((h, i) => (
                        <div key={i} className="flex-1 flex flex-col justify-end">
                          <div className="w-full rounded-sm bg-[#9eb3a4]" style={{ height: `${h}%`, opacity: 0.4 + (h / 200) }} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-center justify-between mb-3">
                    <div className="lp-eyebrow text-[#8a8580]" style={{ fontSize: "10px" }}>Live attendance</div>
                    <div className="lp-mono text-[10px] text-[#0f2d1f] flex items-center gap-1.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
                      3 just now
                    </div>
                  </div>
                  <div className="space-y-2.5">
                    {[
                      { name: "Priya Sharma", at: "New Delhi HQ", time: "9:02" },
                      { name: "Arjun Mehta", at: "Remote · Pune", time: "8:54" },
                      { name: "Kavya Rao", at: "Mumbai office", time: "8:41" },
                    ].map((row, i) => (
                      <div key={i} className="flex items-center gap-3 py-1.5">
                        <div className="w-7 h-7 rounded-full bg-[#e8efe9] text-[#0f2d1f] flex items-center justify-center text-[11px] font-semibold">
                          {row.name.split(" ").map((n) => n[0]).join("")}
                        </div>
                        <div className="flex-1 leading-tight">
                          <div className="text-[13px] text-[#1a1a1a] font-medium">{row.name}</div>
                          <div className="text-[11px] text-[#8a8580]">{row.at}</div>
                        </div>
                        <div className="text-right">
                          <div className="lp-mono text-[11px] text-[#0f2d1f]">{row.time} AM</div>
                          <div className="inline-flex items-center gap-1 text-[10px] text-[#2f9e6c]">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#2f9e6c]" />
                            Clocked in
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -right-2 sm:-right-4 z-30 bg-[#0f2d1f] text-[#faf8f3] rounded-2xl px-5 py-4 max-w-[230px] shadow-[0_18px_40px_-12px_rgba(15,45,31,0.32)]">
              <div className="flex items-center gap-2 mb-1.5">
                <FaRobot className="text-[#d4a356]" />
                <span className="lp-eyebrow" style={{ fontSize: "9px", color: "#9eb3a4" }}>AI suggestion</span>
              </div>
              <div className="text-[12px] leading-snug" style={{ color: "#faf8f3" }}>
                3 employees due for review this week. Generate appraisals?
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <section className="border-y border-[#e8e3d8] bg-[#f4f1ea]">
        <div className="lp-reveal lp-stagger max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10 items-end">
          {[
            { node: <Counter value={10000} suffix="+" />, label: "Companies served" },
            { node: <Counter value={128} prefix="₹" suffix=" Cr" />, label: "Salaries / month" },
            { node: <Counter value={99.9} suffix="%" format={(n) => n.toFixed(1)} />, label: "Uptime guarantee" },
            { node: <span>24 / 7</span>, label: "Indian-language support" },
          ].map((stat, i) => (
            <div key={i} className="relative">
              <div className="lp-eyebrow text-[#8a8580] mb-3" style={{ fontSize: "10px" }}>№ 0{i + 1}</div>
              <div
                className="lp-serif text-[#0f2d1f] mb-2 lp-num-tab"
                style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: "clamp(36px, 5vw, 64px)",
                  lineHeight: 1,
                  letterSpacing: "-0.02em",
                  fontWeight: 500,
                }}
              >
                {stat.node}
              </div>
              <div className="text-[12px] text-[#4a4a4a] uppercase tracking-[0.12em]">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* GUIDED TOUR */}
      <section id="tour" className="px-6 lg:px-10 py-24 lg:py-32 bg-[#faf8f3] relative overflow-hidden">
        <div aria-hidden className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-[#e8efe9] opacity-30 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto">
          <div className="lp-reveal grid lg:grid-cols-12 gap-10 mb-14 items-end">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="lp-eyebrow text-[#0f2d1f]">Section II</span>
                <span className="h-px w-10 bg-[#0f2d1f]/30" />
                <span className="lp-eyebrow text-[#8a8580]">A guided tour</span>
              </div>
              <h2
                className="lp-serif text-[#0f2d1f]"
                style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: "clamp(36px, 5.5vw, 68px)",
                  lineHeight: 1,
                  letterSpacing: "-0.025em",
                  fontWeight: 500,
                }}
              >
                See it <span style={{ fontStyle: "italic" }}>in motion.</span>
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[16px] text-[#4a4a4a] leading-[1.65] max-w-md">
                Four core modules. One calm interface. Watch how each page handles its job —
                or click to skip ahead to the one you care about.
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-start">
            {/* Tab list — compact so total height matches the right frame */}
            <aside className="lp-reveal lp-stagger lg:col-span-4 flex flex-col gap-2">
              {tourModules.map((mod, i) => {
                const isActive = i === activeTour;
                return (
                  <button
                    key={i}
                    onClick={() => {
                      setActiveTour(i);
                      setTourTick((t) => t + 1);
                    }}
                    onMouseEnter={() => setTourPaused(true)}
                    onMouseLeave={() => setTourPaused(false)}
                    className={`lp-tour-tab text-left px-4 py-3 rounded-xl border relative overflow-hidden ${
                      isActive
                        ? "is-active bg-[#0f2d1f] text-[#faf8f3] border-[#0f2d1f]"
                        : "bg-[#faf8f3] text-[#1a1a1a] border-[#e8e3d8] hover:border-[#0f2d1f]/50"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span
                        className="lp-mono shrink-0"
                        style={{ fontSize: "10px", letterSpacing: "0.2em", color: isActive ? "#9eb3a4" : "#8a8580" }}
                      >
                        № 0{i + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <div
                          className="lp-serif truncate"
                          style={{
                            fontFamily: "'Fraunces', Georgia, serif",
                            color: isActive ? "#faf8f3" : "#0f2d1f",
                            fontSize: "16px",
                            lineHeight: 1.15,
                            fontWeight: 500,
                            letterSpacing: "-0.015em",
                          }}
                        >
                          {mod.title}
                        </div>
                        <div
                          className="lp-mono truncate"
                          style={{ fontSize: "9px", letterSpacing: "0.18em", textTransform: "uppercase", color: isActive ? "#9eb3a4" : "#8a8580", marginTop: "2px" }}
                        >
                          {mod.eyebrow}
                        </div>
                      </div>
                      {isActive && (
                        <span className="inline-flex items-center gap-1 lp-mono shrink-0" style={{ fontSize: "8px", letterSpacing: "0.2em", color: "#d4a356" }}>
                          <span className="w-1 h-1 rounded-full bg-[#d4a356] lp-pulse-dot" />
                          LIVE
                        </span>
                      )}
                    </div>
                    {/* Progress bar */}
                    <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-transparent">
                      <div
                        key={`${i}-${tourTick}-${tourPaused ? "p" : "r"}`}
                        className="lp-tour-bar h-full bg-[#d4a356]"
                      />
                    </div>
                  </button>
                );
              })}

              {/* Active module description fills remaining left-column space */}
              <div key={`desc-${activeTour}`} className="lp-fade mt-4 px-2">
                <h3
                  className="lp-serif text-[#0f2d1f] mb-2"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: "20px",
                    lineHeight: 1.15,
                    letterSpacing: "-0.02em",
                    fontWeight: 500,
                  }}
                >
                  {tourModules[activeTour].title}
                </h3>
                <p className="text-[13px] text-[#4a4a4a] leading-[1.6]">
                  {tourModules[activeTour].desc}
                </p>
              </div>
            </aside>

            {/* Frame */}
            <div className="lp-reveal lg:col-span-8 lp-tour-frame relative">
              <div aria-hidden className="absolute -inset-x-4 -bottom-4 h-1/3 rounded-[28px] bg-[#0f2d1f]/8 blur-2xl pointer-events-none" />
              <div className="relative bg-[#faf8f3] border border-[#e8e3d8] rounded-[24px] overflow-hidden shadow-[0_40px_80px_-20px_rgba(15,45,31,0.25),0_8px_20px_-6px_rgba(15,45,31,0.08)]">
                {/* Browser chrome */}
                <div className="flex items-center justify-between px-5 py-3 border-b border-[#efeae0] bg-[#fbf8f1]">
                  <div className="flex items-center gap-1.5">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#c4574c]/70" />
                    <span className="w-2.5 h-2.5 rounded-full bg-[#d4a356]/70" />
                    <span className="w-2.5 h-2.5 rounded-full bg-[#2f9e6c]/70" />
                  </div>
                  <span className="lp-mono text-[10px] text-[#8a8580] hidden sm:inline">
                    teamlio.app/{tourModules[activeTour].tag.toLowerCase()}
                  </span>
                  <div className="flex items-center gap-2">
                    {tourModules.map((_, i) => (
                      <span
                        key={i}
                        className={`w-1.5 h-1.5 rounded-full transition-colors ${
                          i === activeTour ? "bg-[#0f2d1f]" : "bg-[#d6d0c2]"
                        }`}
                      />
                    ))}
                  </div>
                </div>

                {/* Mock dashboard stage — inline, no external images required */}
                <div className="lp-mock-stage relative aspect-[16/11] bg-[#f4f1ea] overflow-hidden">
                  {[0, 1, 2, 3, 4, 5].map((i) => {
                    const isActive = i === activeTour;
                    const isAhead = i > activeTour;
                    // Re-key the active mock so internal animations replay on tab switch
                    const paneKey = isActive ? `${i}-${tourTick}` : `${i}-idle`;
                    return (
                      <div
                        key={paneKey}
                        className={`lp-mock-pane absolute inset-0 ${
                          isActive
                            ? "is-active-pane opacity-100 z-10"
                            : `${isAhead ? "is-entering" : "is-leaving"} opacity-0 z-0 pointer-events-none`
                        }`}
                      >
                        {i === 0 && <DashboardFullMock />}
                        {i === 1 && <EmployeesMock />}
                        {i === 2 && <AttendanceMock />}
                        {i === 3 && <PlannerMock />}
                        {i === 4 && <ReportsMock />}
                        {i === 5 && <ClientsMock />}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Floating caption pill */}
              <div className="absolute -bottom-5 left-6 lg:left-10 z-10 inline-flex items-center gap-3 bg-[#0f2d1f] text-[#faf8f3] rounded-full pl-4 pr-5 py-2.5 shadow-[0_18px_40px_-12px_rgba(15,45,31,0.32)]">
                <span className="w-2 h-2 rounded-full bg-[#d4a356] lp-pulse-dot" />
                <span className="lp-mono text-[10px] tracking-[0.18em] uppercase">
                  Module {String(activeTour + 1).padStart(2, "0")} of 06 · {tourModules[activeTour].tag}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AI EMPLOYEE — premium feature highlight */}
      <section id="ai" className="px-6 lg:px-10 py-24 lg:py-32 bg-[#0f2d1f] text-[#faf8f3] relative overflow-hidden">
        <div aria-hidden className="pointer-events-none absolute inset-0 lp-grain opacity-20 mix-blend-overlay" />
        <div aria-hidden className="pointer-events-none absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#1f4030] opacity-50 blur-3xl" />
        <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#1f4030] opacity-40 blur-3xl" />

        <div className="relative max-w-[1400px] mx-auto">
          <div className="lp-reveal text-center mb-12 lg:mb-16 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-6 flex-wrap">
              <span className="lp-eyebrow" style={{ color: "#9eb3a4" }}>New · Now in beta</span>
              <span className="h-px w-10 bg-[#9eb3a4]/40" />
              <span className="lp-eyebrow inline-flex items-center gap-1.5" style={{ color: "#d4a356" }}>
                <span className="w-1.5 h-1.5 rounded-full bg-[#d4a356] lp-pulse-dot" />
                Free with every plan
              </span>
            </div>
            <h2
              className="lp-serif"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                color: "#faf8f3",
                fontSize: "clamp(36px, 5.5vw, 68px)",
                lineHeight: 1,
                letterSpacing: "-0.025em",
                fontWeight: 500,
              }}
            >
              Get your first
              <br /><span style={{ fontStyle: "italic", color: "#d4a356" }}>AI employee</span>, with Teamlio.
            </h2>
            <p className="text-[16px] leading-[1.65] mt-6 max-w-xl mx-auto" style={{ color: "#9eb3a4" }}>
              Always on, always learning, never asks for leave. Ask questions, draft messages, summarise reports —
              your team's quietest, fastest hire.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            {/* AI chat mock */}
            <div className="lp-reveal lg:col-span-7 relative">
              <div aria-hidden className="absolute -inset-x-4 -bottom-4 h-1/3 rounded-[28px] bg-[#0f2d1f]/40 blur-2xl pointer-events-none" />
              <div className="relative bg-[#faf8f3] border border-[#1f4030] rounded-[20px] overflow-hidden shadow-[0_40px_80px_-20px_rgba(0,0,0,0.45),0_8px_20px_-6px_rgba(0,0,0,0.25)]">
                <div className="flex items-center justify-between px-5 py-3 border-b border-[#efeae0] bg-[#fbf8f1]">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-[#0f2d1f] flex items-center justify-center text-[#d4a356]">
                      <FaRobot className="text-xs" />
                    </div>
                    <div className="leading-tight">
                      <div className="text-[13px] font-semibold text-[#0f2d1f]">Teamlio AI</div>
                      <div className="text-[10px] text-[#8a8580] inline-flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
                        Online · Trained on your data
                      </div>
                    </div>
                  </div>
                  <span className="lp-mono text-[10px] text-[#8a8580]">teamlio.app/ai</span>
                </div>

                <div className="p-5 lg:p-6 space-y-3 lp-mock-stagger" style={{ minHeight: 360 }}>
                  {/* User message */}
                  <div className="flex justify-end">
                    <div className="max-w-[78%] bg-[#0f2d1f] text-[#faf8f3] rounded-2xl rounded-br-sm px-4 py-2.5">
                      <div className="text-[13px]">How many employees were late this week?</div>
                      <div className="lp-mono text-[9px] mt-1" style={{ color: "#9eb3a4" }}>9:14 AM</div>
                    </div>
                  </div>
                  {/* AI message */}
                  <div className="flex justify-start gap-2 items-end">
                    <div className="w-7 h-7 rounded-full bg-[#0f2d1f] flex items-center justify-center shrink-0 text-[#d4a356]">
                      <FaRobot className="text-[10px]" />
                    </div>
                    <div className="max-w-[78%] bg-[#f4f1ea] border border-[#e8e3d8] rounded-2xl rounded-bl-sm px-4 py-2.5">
                      <div className="text-[13px] text-[#1a1a1a]">
                        Three this week. <strong>Priya</strong>, <strong>Arjun</strong>, and <strong>Kavya</strong> — each by under 12 minutes. Want me to draft a friendly nudge?
                      </div>
                      <div className="lp-mono text-[9px] mt-1 text-[#8a8580]">9:14 AM · 0.4s</div>
                    </div>
                  </div>
                  {/* User reply */}
                  <div className="flex justify-end">
                    <div className="max-w-[60%] bg-[#0f2d1f] text-[#faf8f3] rounded-2xl rounded-br-sm px-4 py-2.5">
                      <div className="text-[13px]">Yes, please. Keep it warm.</div>
                      <div className="lp-mono text-[9px] mt-1" style={{ color: "#9eb3a4" }}>9:15 AM</div>
                    </div>
                  </div>
                  {/* AI typing -> reply */}
                  <div className="flex justify-start gap-2 items-end">
                    <div className="w-7 h-7 rounded-full bg-[#0f2d1f] flex items-center justify-center shrink-0 text-[#d4a356]">
                      <FaRobot className="text-[10px]" />
                    </div>
                    <div className="max-w-[78%] bg-[#f4f1ea] border border-[#e8e3d8] rounded-2xl rounded-bl-sm px-4 py-2.5">
                      <div className="text-[13px] text-[#1a1a1a] mb-2">
                        Drafted three messages — same warm tone, different specifics. Review them?
                      </div>
                      <div className="grid grid-cols-3 gap-1.5">
                        {["Priya · 8 min late", "Arjun · 11 min late", "Kavya · 6 min late"].map((m, i) => (
                          <div key={i} className="bg-[#faf8f3] border border-[#e8e3d8] rounded-md px-2 py-1.5 text-[10px] text-[#1a1a1a]">
                            <div className="font-semibold truncate">{m.split(" · ")[0]}</div>
                            <div className="text-[#8a8580] truncate">{m.split(" · ")[1]}</div>
                          </div>
                        ))}
                      </div>
                      <div className="flex items-center gap-2 mt-3 pt-2 border-t border-dashed border-[#d6d0c2]">
                        <button className="text-[11px] bg-[#0f2d1f] text-[#faf8f3] px-3 py-1 rounded-full font-medium">Review drafts →</button>
                        <button className="text-[11px] text-[#0f2d1f]">Skip</button>
                        <span className="lp-mono text-[9px] ml-auto text-[#8a8580]">9:15 AM · 1.2s</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Composer */}
                <div className="px-5 py-3 border-t border-[#efeae0] bg-[#fbf8f1] flex items-center gap-2">
                  <div className="flex-1 text-[12px] text-[#8a8580] flex items-center gap-2">
                    <span className="inline-flex items-center gap-0.5">
                      <span className="w-0.5 h-3 bg-[#0f2d1f] inline-block animate-pulse" />
                    </span>
                    <span>Ask anything about your workforce…</span>
                  </div>
                  <span className="lp-mono text-[10px] bg-[#f4f1ea] border border-[#e8e3d8] px-1.5 py-0.5 rounded text-[#0f2d1f]">⌘K</span>
                </div>
              </div>

              {/* Floating accuracy badge */}
              <div className="hidden md:block absolute -top-5 -right-4 bg-[#faf8f3] text-[#0f2d1f] rounded-2xl px-4 py-2.5 shadow-[0_18px_40px_-12px_rgba(0,0,0,0.4)]">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-[#2f9e6c] lp-pulse-dot" />
                  <div className="leading-tight">
                    <div className="lp-eyebrow" style={{ fontSize: "9px", color: "#8a8580" }}>This week</div>
                    <div className="text-[12px] font-semibold">182 questions · 1.1s avg</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Capability list + CTA */}
            <div className="lp-reveal lp-stagger lg:col-span-5 space-y-4">
              {[
                {
                  Icon: FaRobot,
                  title: "Drafts that sound like your HR team",
                  body: "Performance reviews, leave responses, onboarding emails — written in your tone, ready to send in a click.",
                },
                {
                  Icon: FaChartLine,
                  title: "Plain-English insights",
                  body: "Ask 'why was attendance down last Tuesday?' and get an actual answer, not a chart you have to interpret.",
                },
                {
                  Icon: FaCheckCircle,
                  title: "Spots problems before you do",
                  body: "Flags pay anomalies, late-mark patterns, and reconciliation drift — quietly, on Sunday night, before Monday's standup.",
                },
                {
                  Icon: FaShieldAlt,
                  title: "Your data, your model",
                  body: "Trained only on your organisation. Never used for outside training. Hosted in India, encrypted at rest.",
                },
              ].map((cap, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#1f4030] flex items-center justify-center shrink-0 mt-0.5" style={{ color: "#d4a356" }}>
                    <cap.Icon className="text-sm" />
                  </div>
                  <div className="min-w-0">
                    <div
                      className="lp-serif mb-1"
                      style={{
                        fontFamily: "'Fraunces', Georgia, serif",
                        color: "#faf8f3",
                        fontSize: "18px",
                        lineHeight: 1.2,
                        fontWeight: 500,
                        letterSpacing: "-0.015em",
                      }}
                    >
                      {cap.title}
                    </div>
                    <p className="text-[13px] leading-[1.55]" style={{ color: "#9eb3a4" }}>
                      {cap.body}
                    </p>
                  </div>
                </div>
              ))}

              <div className="flex flex-wrap items-center gap-3 pt-4">
                <button
                  onClick={() => scrollToSection("register")}
                  className="inline-flex items-center gap-2 bg-[#faf8f3] text-[#0f2d1f] px-5 py-3 rounded-full font-medium lp-press hover:bg-white group"
                >
                  Hire your AI <FaArrowRight className="text-xs lp-link-arrow" />
                </button>
                <span className="lp-mono text-[11px]" style={{ color: "#9eb3a4", letterSpacing: "0.18em", textTransform: "uppercase" }}>
                  ₹0 forever · No add-on charges
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LOGIN / REGISTER */}
      <section id="login" className="px-6 lg:px-10 py-24 lg:py-32 bg-[#faf8f3]">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left: editorial intro + register CTA */}
          <div className="lp-reveal lg:col-span-5">
            <div className="flex items-center gap-3 mb-6 flex-wrap">
              <span className="lp-eyebrow text-[#0f2d1f]">Section III</span>
              <span className="h-px w-10 bg-[#0f2d1f]/30" />
              <span className="lp-eyebrow text-[#8a8580]">Sign in</span>
            </div>
            <h2
              className="lp-serif text-[#0f2d1f] mb-6"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: "clamp(34px, 4.5vw, 56px)",
                lineHeight: 1.02,
                letterSpacing: "-0.025em",
                fontWeight: 500,
              }}
            >
              Your workspace,
              <br /><span style={{ fontStyle: "italic" }}>where you left it.</span>
            </h2>
            <p className="text-[16px] text-[#4a4a4a] leading-[1.6] max-w-md mb-10">
              Sign in to your organization, or start a new account in under a minute.
              We'll remember every preference, every approval, every payslip.
            </p>

            <div id="register" className="rounded-[20px] bg-[#0f2d1f] text-[#faf8f3] p-8 lg:p-10 relative overflow-hidden">
              <div aria-hidden className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#1f4030] opacity-60" />
              <div aria-hidden className="absolute inset-0 lp-grain opacity-20 mix-blend-overlay" />
              <div className="relative">
                <div className="lp-eyebrow mb-4" style={{ fontSize: "10px", color: "#d4a356" }}>New here?</div>
                <h3
                  className="lp-serif mb-3"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: "#faf8f3",
                    fontSize: "clamp(26px, 3vw, 34px)",
                    lineHeight: 1.1,
                    letterSpacing: "-0.02em",
                    fontWeight: 500,
                  }}
                >
                  Begin a 30-day trial
                </h3>
                <p className="text-[14px] leading-[1.6] mb-6" style={{ color: "#9eb3a4" }}>
                  Full access to every module. No credit card. Setup in under five minutes.
                </p>
                <ul className="space-y-2.5 mb-8">
                  {[
                    "Unlimited employees during trial",
                    "All modules unlocked",
                    "Free data import + onboarding call",
                    "Cancel any time — no questions",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-[13px]" style={{ color: "#faf8f3" }}>
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#d4a356] shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => navigate("/register")}
                  className="w-full inline-flex items-center justify-center gap-3 bg-[#faf8f3] text-[#0f2d1f] px-6 py-3.5 rounded-full font-medium lp-press hover:bg-white group"
                >
                  Create your account
                  <FaArrowRight className="text-xs lp-link-arrow" />
                </button>
              </div>
            </div>
          </div>

          {/* Right: login form */}
          <div className="lp-reveal lg:col-span-7">
            <div className="bg-[#faf8f3] border border-[#e8e3d8] rounded-[24px] p-8 lg:p-12 relative">
              <div className="flex items-center justify-between mb-8 pb-6 border-b border-dashed border-[#d6d0c2] gap-4">
                <div>
                  <div className="lp-eyebrow text-[#8a8580] mb-2" style={{ fontSize: "10px" }}>
                    {loginStep === "email" && "Step 01 of 02"}
                    {loginStep === "organizations" && "Step 02 of 03"}
                    {loginStep === "login" && (organizations.length > 1 ? "Step 03 of 03" : "Step 02 of 02")}
                  </div>
                  <h3
                    className="lp-serif text-[#0f2d1f]"
                    style={{
                      fontFamily: "'Fraunces', Georgia, serif",
                      fontSize: "clamp(24px, 2.4vw, 30px)",
                      lineHeight: 1.15,
                      letterSpacing: "-0.02em",
                      fontWeight: 500,
                    }}
                  >
                    {loginStep === "email" && "Sign in to your workspace"}
                    {loginStep === "organizations" && "Choose your organization"}
                    {loginStep === "login" && organizations.length === 1 && (
                      <>Welcome back to <span style={{ fontStyle: "italic" }}>{selectedOrg?.company_name}</span></>
                    )}
                    {loginStep === "login" && organizations.length > 1 && (
                      <>Sign in to <span style={{ fontStyle: "italic" }}>{selectedOrg?.company_name}</span></>
                    )}
                  </h3>
                </div>
                <div className="hidden md:flex items-center gap-1.5 shrink-0">
                  {[1, 2, 3].map((n) => {
                    const isActive =
                      (n === 1 && loginStep === "email") ||
                      (n === 2 && loginStep === "organizations") ||
                      (n === 3 && loginStep === "login");
                    const isPast =
                      (n === 1 && loginStep !== "email") ||
                      (n === 2 && loginStep === "login");
                    return (
                      <span
                        key={n}
                        className={`w-2 h-2 rounded-full ${isActive ? "bg-[#0f2d1f]" : isPast ? "bg-[#1f4030]" : "bg-[#d6d0c2]"}`}
                      />
                    );
                  })}
                </div>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                {loginStep === "email" && (
                  <div>
                    <label className="lp-eyebrow text-[#8a8580] block mb-2" style={{ fontSize: "10px" }}>Work email</label>
                    <input
                      type="email"
                      placeholder="you@company.com"
                      {...register("email", { required: true })}
                      className="lp-input"
                    />
                  </div>
                )}

                {loginStep === "organizations" && (
                  <div>
                    <label className="lp-eyebrow text-[#8a8580] block mb-3" style={{ fontSize: "10px" }}>
                      {organizations.length} workspaces found for {loginEmail}
                    </label>
                    <div className="space-y-2 max-h-[360px] overflow-y-auto pr-2 -mr-2">
                      {organizations.map((org, idx) => (
                        <button
                          key={idx}
                          type="button"
                          onClick={() => handleSelectOrganization(org)}
                          className="w-full text-left p-4 border border-[#e8e3d8] hover:border-[#0f2d1f] rounded-2xl transition-all group bg-[#fbf8f1] hover:bg-[#f4f1ea]"
                        >
                          <div className="flex items-center gap-4">
                            <div className="w-11 h-11 rounded-xl bg-[#e8efe9] flex items-center justify-center text-[#0f2d1f]">
                              <FaBuilding />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div
                                className="lp-serif text-[#0f2d1f] truncate"
                                style={{
                                  fontFamily: "'Fraunces', Georgia, serif",
                                  fontSize: "18px",
                                  fontWeight: 500,
                                  letterSpacing: "-0.01em",
                                }}
                              >
                                {org.company_name}
                              </div>
                              <div className="text-[12px] text-[#8a8580] truncate">{org.organization}</div>
                            </div>
                            <FaArrowRight className="text-[#0f2d1f] text-xs lp-link-arrow shrink-0" />
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {loginStep === "login" && (
                  <div>
                    <label className="lp-eyebrow text-[#8a8580] block mb-2" style={{ fontSize: "10px" }}>Password</label>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="••••••••"
                        {...register("password", { required: true })}
                        className="lp-input pr-10"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-1 top-3 text-[#8a8580] p-2 hover:text-[#0f2d1f] transition-colors"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    {selectedOrg && (
                      <div className="mt-4 inline-flex items-center gap-2 px-3 py-2 bg-[#e8efe9] rounded-full text-[12px] text-[#0f2d1f]">
                        <FaBuilding className="text-[10px]" />
                        Signing in to <strong className="font-semibold">{selectedOrg.company_name}</strong>
                      </div>
                    )}
                  </div>
                )}

                <div className="pt-4 flex flex-col sm:flex-row gap-3">
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex-1 inline-flex items-center justify-center gap-2 bg-[#0f2d1f] text-[#faf8f3] py-3.5 rounded-full font-medium lp-press hover:bg-[#0a1f15] disabled:opacity-60 disabled:cursor-not-allowed group"
                  >
                    {loading ? (
                      <>
                        <span className="w-4 h-4 rounded-full border-2 border-[#faf8f3] border-t-transparent animate-spin" />
                        <span>Working…</span>
                      </>
                    ) : (
                      <>
                        <span>
                          {loginStep === "email" && "Continue"}
                          {loginStep === "organizations" && "Select organization"}
                          {loginStep === "login" && "Sign in"}
                        </span>
                        <FaArrowRight className="text-xs lp-link-arrow" />
                      </>
                    )}
                  </button>
                  {loginStep === "organizations" && (
                    <button
                      type="button"
                      onClick={handleBackToEmail}
                      className="px-6 py-3 text-[13px] text-[#0f2d1f] hover:bg-[#ece8df] rounded-full transition-colors"
                    >
                      ← Back
                    </button>
                  )}
                  {loginStep === "login" && organizations.length > 1 && (
                    <button
                      type="button"
                      onClick={handleBackToOrganizations}
                      className="px-6 py-3 text-[13px] text-[#0f2d1f] hover:bg-[#ece8df] rounded-full transition-colors"
                    >
                      ← Back
                    </button>
                  )}
                </div>
              </form>

              {loginStep === "email" && (
                <div className="mt-8 pt-6 border-t border-dashed border-[#d6d0c2] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[13px]">
                  <button
                    onClick={() => navigate("/forgot-password")}
                    className="text-[#0f2d1f] hover:underline"
                  >
                    Forgot password?
                  </button>
                  <button
                    onClick={() => navigate("/register")}
                    className="text-[#8a8580] hover:text-[#0f2d1f] transition-colors group inline-flex items-center gap-1.5"
                  >
                    New here? Create account <FaArrowRight className="text-[10px] lp-link-arrow" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="features" className="px-6 lg:px-10 py-24 lg:py-32 relative">
        <div className="max-w-[1400px] mx-auto">
          <div className="lp-reveal grid lg:grid-cols-12 gap-10 mb-16 items-end">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="lp-eyebrow text-[#0f2d1f]">Section IV</span>
                <span className="h-px w-10 bg-[#0f2d1f]/30" />
                <span className="lp-eyebrow text-[#8a8580]">The toolkit</span>
              </div>
              <h2
                className="lp-serif text-[#0f2d1f]"
                style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: "clamp(36px, 5.5vw, 68px)",
                  lineHeight: 1.0,
                  letterSpacing: "-0.025em",
                  fontWeight: 500,
                }}
              >
                <span style={{ fontStyle: "italic" }}>Six</span> tools doing the
                <br />work of <span style={{ fontStyle: "italic" }}>sixty</span>.
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[16px] text-[#4a4a4a] leading-[1.65] max-w-md">
                Each module is built to remove a specific kind of paper-shuffling. Together, they
                quietly take over the hours you used to spend reconciling spreadsheets at month-end.
              </p>
            </div>
          </div>

          <div className="lp-reveal lp-stagger grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
            {features.map((feature, index) => (
              <article
                key={index}
                className="lp-feature-card lp-feature-glow group relative bg-[#faf8f3] border border-[#e8e3d8] rounded-[20px] p-6 lg:p-7 flex flex-col cursor-pointer overflow-hidden"
              >
                <div aria-hidden className="absolute inset-0 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-500" style={{ background: "radial-gradient(circle at 80% 0%, rgba(212,163,86,0.08), transparent 60%)" }} />
                <div className="relative flex items-start justify-between mb-6">
                  <span className="lp-mono text-[11px] tracking-[0.18em] text-[#8a8580]">№ 0{index + 1}</span>
                  <div className="w-11 h-11 rounded-full bg-[#e8efe9] text-[#0f2d1f] flex items-center justify-center text-base group-hover:bg-[#0f2d1f] group-hover:text-[#faf8f3] transition-colors duration-400">
                    {feature.icon}
                  </div>
                </div>
                <h3
                  className="relative lp-serif text-[#0f2d1f] mb-3"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: "clamp(22px, 2vw, 26px)",
                    lineHeight: 1.1,
                    letterSpacing: "-0.02em",
                    fontWeight: 500,
                  }}
                >
                  {feature.title}
                </h3>
                <p className="relative text-[14px] text-[#4a4a4a] leading-[1.6] mb-5 flex-1">
                  {feature.description}
                </p>
                <div className="relative flex items-center justify-between pt-4 border-t border-dashed border-[#d6d0c2]">
                  <div className="flex flex-wrap gap-1.5">
                    {feature.tags.map((tag, j) => (
                      <span key={j} className="text-[10px] px-2 py-0.5 rounded-full bg-[#f4f1ea] border border-[#e8e3d8] text-[#4a4a4a]">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <FaArrowRight className="text-[#0f2d1f] text-xs lp-link-arrow shrink-0 ml-3" />
                </div>
              </article>
            ))}
          </div>

          {/* Capabilities strip */}
          <div className="lp-reveal lp-stagger mt-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#e8e3d8] border border-[#e8e3d8] rounded-[16px] overflow-hidden">
            {capabilities.map((c, i) => (
              <div key={i} className="bg-[#faf8f3] p-5 flex items-start gap-3 lp-soft-hover">
                <div className="w-9 h-9 rounded-lg bg-[#e8efe9] text-[#0f2d1f] flex items-center justify-center text-sm shrink-0">
                  {c.icon}
                </div>
                <div className="min-w-0">
                  <div className="text-[13px] font-semibold text-[#0f2d1f] mb-1">{c.title}</div>
                  <div className="text-[11px] text-[#4a4a4a] leading-[1.5]">{c.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="process" className="bg-[#0f2d1f] text-[#faf8f3] px-6 lg:px-10 py-24 lg:py-32 relative overflow-hidden">
        <div aria-hidden className="absolute inset-0 lp-grain opacity-20 mix-blend-overlay" />
        <div className="lp-reveal relative max-w-[1400px] mx-auto">
          <div className="flex items-center gap-3 mb-8 flex-wrap">
            <span className="lp-eyebrow" style={{ color: "#9eb3a4" }}>Section V</span>
            <span className="h-px w-10 bg-[#9eb3a4]/40" />
            <span className="lp-eyebrow" style={{ color: "#9eb3a4" }}>A quiet workflow</span>
          </div>
          <h2
            className="lp-serif max-w-3xl mb-16"
            style={{
              fontFamily: "'Fraunces', Georgia, serif",
              color: "#faf8f3",
              fontSize: "clamp(36px, 5.5vw, 68px)",
              lineHeight: 1,
              letterSpacing: "-0.025em",
              fontWeight: 500,
            }}
          >
            From <span style={{ fontStyle: "italic" }}>chaos</span> to <span style={{ fontStyle: "italic" }}>closing</span>
            <br />in three calm steps.
          </h2>

          <div className="lp-reveal lp-stagger grid md:grid-cols-3 gap-px bg-[#1f4030] rounded-[20px] overflow-hidden">
            {[
              { n: "01", title: "Connect your team", body: "Bulk-import employees in 30 seconds. Map roles, locations, and approval chains visually — no spreadsheets required." },
              { n: "02", title: "Let attendance flow", body: "Employees clock in via app, web, or WhatsApp. GPS, selfie, and IP all verified silently in the background." },
              { n: "03", title: "Run payroll on autopilot", body: "Salaries, taxes, payslips — generated, reviewed, and disbursed in a single approval. Reconciles itself overnight." },
            ].map((step, i) => (
              <div key={i} className="bg-[#0f2d1f] p-8 lg:p-10">
                <div
                  className="lp-serif mb-6"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: "#9eb3a4",
                    opacity: 0.55,
                    fontSize: "84px",
                    lineHeight: 1,
                    fontWeight: 500,
                  }}
                >
                  {step.n}
                </div>
                <h3
                  className="lp-serif mb-4"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: "#faf8f3",
                    fontSize: "26px",
                    lineHeight: 1.15,
                    fontWeight: 500,
                    letterSpacing: "-0.01em",
                  }}
                >
                  {step.title}
                </h3>
                <p className="text-[14px] leading-[1.6]" style={{ color: "#9eb3a4" }}>
                  {step.body}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-16 flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8 pt-10 border-t border-[#1f4030]">
            <div
              className="lp-serif max-w-2xl"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                color: "#faf8f3",
                fontStyle: "italic",
                fontSize: "clamp(20px, 2.4vw, 32px)",
                lineHeight: 1.25,
                fontWeight: 400,
              }}
            >
              "We closed our first month of payroll in 18 minutes — used to take a full Friday."
            </div>
            <div className="text-right shrink-0">
              <div className="text-[14px] font-semibold" style={{ color: "#faf8f3" }}>Anita Krishnan</div>
              <div className="lp-eyebrow" style={{ fontSize: "10px", color: "#9eb3a4" }}>Head of People · 240-person co.</div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="px-6 lg:px-10 py-24 lg:py-32 bg-[#f4f1ea] border-y border-[#e8e3d8]">
        <div className="max-w-[1400px] mx-auto">
          <div className="lp-reveal text-center mb-16 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-6 flex-wrap">
              <span className="lp-eyebrow text-[#0f2d1f]">Section VI</span>
              <span className="h-px w-10 bg-[#0f2d1f]/30" />
              <span className="lp-eyebrow text-[#8a8580]">Pricing</span>
            </div>
            <h2
              className="lp-serif text-[#0f2d1f] mb-6"
              style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: "clamp(36px, 5.5vw, 68px)",
                lineHeight: 1,
                letterSpacing: "-0.025em",
                fontWeight: 500,
              }}
            >
              Honest pricing, <span style={{ fontStyle: "italic" }}>no asterisks.</span>
            </h2>
            <p className="text-[16px] text-[#4a4a4a] leading-[1.65]">
              One subscription covers every module. No add-ons, no per-payslip fees, no surprises.
              Switch tiers any time as you grow.
            </p>
          </div>

          <div className="lp-reveal lp-stagger grid md:grid-cols-3 gap-px bg-[#d6d0c2] border border-[#d6d0c2] rounded-[24px] overflow-hidden">
            {[
              {
                name: "Starter",
                tag: "For new teams",
                price: "₹399",
                period: "/ month",
                features: [
                  "Up to 10 employees",
                  "Attendance + payroll",
                  "Mobile + WhatsApp app",
                  "Email support",
                ],
                cta: "Begin starter trial",
                accent: false,
              },
              {
                name: "Professional",
                tag: "Most chosen",
                price: "₹899",
                period: "/ month",
                features: [
                  "Up to 50 employees",
                  "AI analytics + insights",
                  "Auto bank reconciliation",
                  "Priority chat support",
                  "Custom approval flows",
                ],
                cta: "Try Professional free",
                accent: true,
              },
              {
                name: "Enterprise",
                tag: "Custom-fit",
                price: "Custom",
                period: "talk to us",
                features: [
                  "Unlimited employees",
                  "Dedicated success lead",
                  "API + SSO + audit logs",
                  "On-prem option",
                  "Negotiated SLAs",
                ],
                cta: "Speak with sales",
                accent: false,
              },
            ].map((tier, i) => (
              <div
                key={i}
                className={`relative p-8 lg:p-10 ${tier.accent ? "bg-[#0f2d1f] text-[#faf8f3]" : "bg-[#faf8f3]"}`}
              >
                {tier.accent && (
                  <div className="absolute top-6 right-6 lp-mono text-[10px] tracking-[0.18em] uppercase bg-[#d4a356] text-[#0f2d1f] px-2.5 py-1 rounded-full font-semibold">
                    ★ Chosen
                  </div>
                )}
                <div
                  className="lp-eyebrow mb-3"
                  style={{ fontSize: "10px", color: tier.accent ? "#9eb3a4" : "#8a8580" }}
                >
                  {tier.tag}
                </div>
                <div
                  className="lp-serif mb-6"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: tier.accent ? "#faf8f3" : "#0f2d1f",
                    fontSize: "28px",
                    lineHeight: 1.1,
                    fontWeight: 500,
                    letterSpacing: "-0.01em",
                  }}
                >
                  {tier.name}
                </div>
                <div className="flex items-baseline gap-2 mb-2 flex-wrap">
                  <span
                    className="lp-serif"
                    style={{
                      fontFamily: "'Fraunces', Georgia, serif",
                      color: tier.accent ? "#faf8f3" : "#0f2d1f",
                      fontSize: "clamp(48px, 5.5vw, 68px)",
                      lineHeight: 1,
                      fontWeight: 500,
                      letterSpacing: "-0.025em",
                    }}
                  >
                    {tier.price}
                  </span>
                  <span className="text-[14px]" style={{ color: tier.accent ? "#9eb3a4" : "#8a8580" }}>
                    {tier.period}
                  </span>
                </div>
                <div
                  className="lp-dotted-h h-2 my-6"
                  style={{ color: tier.accent ? "#1f4030" : "#d6d0c2" }}
                />
                <ul className="space-y-3 mb-10">
                  {tier.features.map((f, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-3 text-[14px]"
                      style={{ color: tier.accent ? "#faf8f3" : "#1a1a1a" }}
                    >
                      <FaCheckCircle
                        className="mt-1 text-[12px] shrink-0"
                        style={{ color: tier.accent ? "#d4a356" : "#0f2d1f" }}
                      />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollToSection("register")}
                  className={`w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full font-medium lp-press group ${
                    tier.accent
                      ? "bg-[#faf8f3] text-[#0f2d1f] hover:bg-white"
                      : "bg-[#0f2d1f] text-[#faf8f3] hover:bg-[#0a1f15]"
                  }`}
                >
                  {tier.cta}
                  <FaArrowRight className="text-xs lp-link-arrow" />
                </button>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center text-[13px] text-[#8a8580]">
            All plans include EPF/ESI/TDS compliance, daily backups, and end-to-end encryption.
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0f2d1f] text-[#faf8f3] relative overflow-hidden">
        <div aria-hidden className="absolute inset-0 lp-grain opacity-20 mix-blend-overlay" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
          <div className="lp-reveal grid lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
            <div className="lg:col-span-7">
              <div className="lp-eyebrow mb-4" style={{ fontSize: "10px", color: "#9eb3a4" }}>Colophon</div>
              <h3
                className="lp-serif max-w-2xl"
                style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  color: "#faf8f3",
                  fontSize: "clamp(32px, 4.5vw, 56px)",
                  lineHeight: 1.05,
                  letterSpacing: "-0.025em",
                  fontWeight: 500,
                }}
              >
                Quietly running payroll for <span style={{ fontStyle: "italic" }}>10,000+</span> Indian companies.
              </h3>
            </div>
            <div className="lg:col-span-5 flex flex-col justify-end">
              <p className="text-[14px] leading-[1.6] mb-6" style={{ color: "#9eb3a4" }}>
                Set up an account in five minutes, or schedule a demo with one of our specialists.
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={() => navigate("/register")}
                  className="inline-flex items-center gap-2 bg-[#faf8f3] text-[#0f2d1f] px-5 py-3 rounded-full text-[14px] font-medium lp-press hover:bg-white group"
                >
                  Start free trial <FaArrowRight className="text-xs lp-link-arrow" />
                </button>
                <a
                  href="mailto:support@startupkhata.com"
                  className="inline-flex items-center gap-2 border border-[#9eb3a4]/40 text-[#faf8f3] px-5 py-3 rounded-full text-[14px] font-medium hover:border-[#faf8f3] transition-colors"
                >
                  Talk to sales
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-12 border-t border-[#1f4030]">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-full bg-[#faf8f3] flex items-center justify-center">
                  <FaUserClock className="text-[#0f2d1f] text-sm" />
                </div>
                <span
                  className="lp-serif"
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: "#faf8f3",
                    fontSize: "18px",
                    fontWeight: 600,
                    letterSpacing: "-0.01em",
                  }}
                >
                  Teamlio
                </span>
              </div>
              <p className="text-[12px] leading-[1.55]" style={{ color: "#9eb3a4" }}>
                Built in New Delhi. Made for India's growing companies.
              </p>
            </div>

            <div>
              <div className="lp-eyebrow mb-4" style={{ fontSize: "10px", color: "#9eb3a4" }}>Product</div>
              <ul className="space-y-2.5">
                {([
                  ["Features", "features"],
                  ["How it works", "process"],
                  ["Pricing", "pricing"],
                  ["Sign in", "login"],
                ] as const).map(([label, target]) => (
                  <li key={label}>
                    <button
                      onClick={() => scrollToSection(target)}
                      className="text-[13px] hover:text-[#faf8f3] transition-colors"
                      style={{ color: "#9eb3a4" }}
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="lp-eyebrow mb-4" style={{ fontSize: "10px", color: "#9eb3a4" }}>Company</div>
              <ul className="space-y-2.5">
                <li>
                  <button
                    onClick={() => navigate("/privacy-policy")}
                    className="text-[13px] hover:text-[#faf8f3] transition-colors"
                    style={{ color: "#9eb3a4" }}
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => navigate("/terms-and-conditions")}
                    className="text-[13px] hover:text-[#faf8f3] transition-colors"
                    style={{ color: "#9eb3a4" }}
                  >
                    Terms &amp; Conditions
                  </button>
                </li>
                <li>
                  <a
                    href="mailto:support@startupkhata.com"
                    className="text-[13px] hover:text-[#faf8f3] transition-colors"
                    style={{ color: "#9eb3a4" }}
                  >
                    Support
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <div className="lp-eyebrow mb-4" style={{ fontSize: "10px", color: "#9eb3a4" }}>Reach us</div>
              <ul className="space-y-2.5 text-[13px]" style={{ color: "#9eb3a4" }}>
                <li>info@startupkhata.com</li>
                <li>support@startupkhata.com</li>
                <li>Mon–Sun · 24/7</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-16 pt-8 border-t border-[#1f4030]">
            <div className="lp-mono text-[11px]" style={{ color: "#9eb3a4" }}>
              © {new Date().getFullYear()} Teamlio · A StartupKhata company
            </div>
            <div className="lp-mono text-[11px]" style={{ color: "#9eb3a4" }}>
              Set in Fraunces &amp; Plus Jakarta Sans · Volume 01
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;